<template>
    <div class="page-layout blank contacts-manage mb-10">
        <div class="breadcrumbactive">
            <div >
                <span class="pointer" @click="goToListView">Tickets</span>
                <div >Create New</div>
            </div>
        </div>
        <div class="general-section pt-2 pb-6 pl-4 pr-4 mt-0">
            <div class="mt-5 mb-5">
                <div class="general-section pb-6 mt-3 px-0 px-lg-4">
                    <div class="row justify-content-between boxHeader mt-4 py-2">
                        <div>General Details</div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                            <div class="w-100">
                                <div class="d-flex flex-column pt-2" :class="{'justify-content-start': template_type == 'multi_part', 'justify-content-between': template_type == 'default'}">
                                    <label class="inputLabel fs-14 fw-600 text-black">Subject <span class="text-danger"> *</span></label>
                                    <input v-validate="'required'" name="subject" class="inputFieldNew overflowing-text" autocomplete="off" style="padding-right: 30px !important;" type="text" :maxlength="subjectlength" v-model="subject" placeholder="Enter Ticket Subject" />
                                </div>
                                <span class="inputBorder"></span>
                                <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('subject')" style="display: inline !important">{{ errors.first("subject") }}</span>
                                <span class="pull-right text-right font-600 fs-12 pt-1">{{ subjectlength - subject.length}}/{{subjectlength}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 mt-3">
                            <div class="form-group contactGroup pt-0">
                                <div class="d-flex flex-column pt-2" :class="{'justify-content-start': template_type == 'multi_part', 'justify-content-between': template_type == 'default'}">
                                    <span class="fs-13 fw-600 text-black">
                                        Ticket Template<span class="text-danger"> *</span>
                                    </span>
                                    <div class="d-flex align-items-center mt-4">
                                        <multiselect :title="ticketType.name"
                                            v-model="ticketType" autocomplete="off"
                                            class="diginew-multiselect overflow-text custom-cred-fs"
                                            :loading="ticket_type_loading"
                                            :options="ticket_type_options"
                                            :searchable="true"
                                            :close-on-select="true"
                                            name="ticketType"
                                            :show-labels="false"
                                            @select="selectedTemplate"
                                            @open="getTicketTemplate"
                                            @close="checkTicketType"
                                            @search-change="searchTemplate"
                                            :multiple="false"
                                            :options-limit="3000"
                                            :max-height="200"
                                            v-validate="'required'"
                                            :clear-on-select="false"
                                            label="name" track-by="_id"
                                            :internal-search="false"
                                            :show-no-results="true"
                                            :hide-selected="false"
                                        >
                                            <template slot="placeholder">
                                                <span class="diginewhelp-multiselect">Select Ticket Template</span>
                                            </template>
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfTicketTemplate" />
                                            </template>
                                            <template slot="noResult">
                                                <div v-if="ticket_type_options.length">
                                                    <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                </div>
                                                <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('ticketType')">{{ errors.first("ticketType") }}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12" v-if="template_type == 'default'">
                            <div class="form-group contactGroup d-flex flex-column justify-content-between" style="margin-top: 0px;z-index:1 !important;">
                                <div class="vendor_type">
                                    <label class="text-black mr-2" style="font-size: 14px;margin-bottom: 0px;">Assigned to
                                        <span class="text-danger ml-0">*</span>
                                        <span style="position:absolute;top:10px;left:auto; margin-left: 5px;">
                                            <el-tooltip class="item pull-right" effect="dark" content="Employees" placement="top">
                                                <i class="icon icon-information text-secondary fs-13"></i>
                                            </el-tooltip>
                                        </span>
                                    </label>
                                    <el-radio-group class="d-flex align-items-center mt-2 mob-issue-fix" v-model="assignedTo">
                                        <el-tooltip class="item pull-right" v-if="template_type == 'multi_part'" effect="dark" content="A Person cannot be assigned to Multi Part Templates" placement="top">
                                            <el-radio :disabled="template_type == 'multi_part'" @input="assignedToChange()" label="person">
                                                Person
                                            </el-radio>
                                        </el-tooltip>
                                        <el-radio v-else @input="assignedToChange()" label="person">
                                            Person
                                        </el-radio>
                                        <el-tooltip class="item pull-right" effect="dark" content="Assigning Tickets To Teams Coming Soon" placement="top">
                                            <el-radio disabled @input="assignedToChange()" label="team">
                                                Team
                                            </el-radio>
                                        </el-tooltip>
                                        <el-radio @input="assignedToChange()" label="unassigned">
                                            Unassigned
                                        </el-radio>
                                    </el-radio-group>
                                </div>
                                <div v-if="assignedTo == 'unassigned'" class="inputFieldNew" style="padding: 12px 11px 8px 8px !important;border-radius: 8px !important;" >
                                    Unassigned
                                </div>
                                <multiselect v-else label="name"
                                    v-validate="'required'"
                                    class="diginew-multiselect mt-3 custom-cred-fs"
                                    name="assigned" open-direction="top"
                                    v-model="assignedCustomer" :options-limit="3000"
                                    :max-height="200"
                                    :options="assign_options"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    :loading="assign_loading" @search-change="getAllAssignTo"
                                >
                                        <template slot="placeholder">
                                            <span class="diginewhelp-multiselect">Select Name</span>
                                        </template>
                                    <template slot="afterList">
                                        <div v-observe-visibility="reachedEndOfAssigned" />
                                    </template>
                                    <template slot="noResult">
                                        <div v-if="assign_options.length">
                                            <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                                <div></div>
                                            </div>
                                        </div>
                                        <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect>
                            </div>
                            <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('assigned')">{{ errors.first("assigned") }}</span>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12 mt-3" v-if="is_approvers_mandatory">
                            <div class="form-group contactGroup pt-0">
                                <span class="fs-13 fw-600 text-black">
                                    Approver <span class="text-danger"> *</span>
                                </span>
                                <div class="d-flex align-items-center mt-3">
                                    <multiselect
                                        v-model="approvers_data" id="ajax" :block-keys="['Tab', 'Enter']"
                                        class="diginew-multiselect overflow-text arrow-custom h-100px-ms filter-multiple custom-cred-fs"
                                        :options="approvers_options"
                                        data-vv-as="Approver" track-by="id"
                                        :searchable="true"
                                        :close-on-select="false"
                                        name="approversData"
                                        :show-labels="false"
                                        :multiple="true"
                                        :options-limit="3000"
                                        :max-height="200"
                                        :min-height="100"
                                        v-validate="is_approvers_mandatory ? 'required' : ''"
                                        :clear-on-select="true"
                                        label="name"
                                        :internal-search="true"
                                        :show-no-results="true"
                                        :allow-empty="true"
                                        :hide-selected="true"
                                        :blockKeys="['Delete']"
                                    >
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="custom__tag1">
                                            <span class="filterSelectedName1">{{ option.name }}</span>
                                                <span class="custom__remove pointer">
                                                    <i class="icon icon-close fs-16 text-white" style="display:none"></i>
                                                </span>
                                                <span class="custom__remove pointer" @click="removeApprovers(option)">
                                                <i class="icon icon-close fs-16 text-white"></i>
                                                </span>
                                            </span>
                                        </template>
                                        <template slot="afterList" v-if="watchApprovers">
                                            <div class="d-flex align-items-center justify-content-center" style="height:40px !important">
                                                <span class="diginewhelp-multiselect">All the options are selected</span>
                                            </div>
                                        </template>
                                        <template slot="placeholder">
                                            <span class="diginewhelp-multiselect">Select Approvers</span>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">No Options Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <span class="invalid-feedback-form text-danger mt-0 text-left d-block position-absolute" v-show="errors.has('approversData')">{{ errors.first("approversData") }}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group contactGroup" style="margin-top: 0px;z-index:1 !important;height:75%">
                                <label class="text-black mr-2" style="font-size: 14px">Description</label>
                                <!-- <textarea rows="5" name="description" placeholder="Enter Description" class="w-100 mt-1 fw-600" style="height:101%;border: 1px solid #676767;border-radius:5px;padding: 5px 10px;" maxlength="1000" v-model="description"></textarea> -->
                                <vue-editor :counter="200" @text-change="onTextChange" ref="editor"
                                maxlength="1000" name="description" placeholder="Enter Description" class="desc-editor my-2" v-model="description"></vue-editor>
                                <span class="pull-right text-right font-600 fs-12">{{ 1000 - description.length}}/{{1000}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- attachments -->
                <div class="general-section pb-6 mt-3 px-0 px-lg-4" v-if="generalActive">
                    <div class="row justify-content-between boxHeader mt-4 py-2" v-if="template_type == 'default' || template_type == 'multi_part'">
                        <div>Ticket Details</div>
                    </div>
                    <div v-if="template_type == 'multi_part'">
                        <div class="dynamic-section px-5  mt-4 py-4" :class="field_index > 0 && is_approvers_mandatory ? 'bg-grey' : ''" v-for="(field, field_index) in template_details" :key="field_index">
                            <div class="infoHeader mt-2">
                                <div class="descriptionheader">
                                    <div class="description-text-header-left">
                                        <h5 class="font-weight-bold text-black whiteSpace" :title="field.part_name">{{ field.part_name.split('').length > 1 ?  field.part_name[0].toUpperCase() +''+ field.part_name.slice(1,) : field.part_name[0].toUpperCase()}}</h5>
                                    </div>
                                    <div class="description-text-header-right" v-if="is_approvers_mandatory && field_index > 0"></div>
                                    <div class="description-text-header-right" v-else>
                                        <span class="collapse-addon" v-if="field.show">
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" @click="ToggleParts(field)" alt="" style="top: 9px !important;transition:0.5s">
                                        </span>
                                        <span class="collapse-addon" v-else>
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/main-collapse.svg" alt="" @click="ToggleParts(field)" style="top: 9px !important;transform: rotate(180deg);transition:0.5s">
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="field.show">
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-5" v-for="(td, i) in field.parts_data" :key='i'>
                                    <div class="d-flex flex-column justify-content-start" style="box-shadow: 0 0 2px 0 #939393;border: solid 0.3px #6c6d6f;border-radius: 6px !important;padding: 10px">
                                        <div class="fw-600 pt-2 pb-2 fs-13 text-black d-inline-block w-100 overflowing-text" :title="td.name">{{td.name.split('').length > 1 ?  td.name[0].toUpperCase() +''+ td.name.slice(1,) : td.name[0].toUpperCase()}}<span class="text-danger" v-if="td.required == true"> *</span></div>
                                        <div>
                                            <!-- Short Answer -->
                                            <input v-if="td.type == 'short_answer'"
                                            class="border-bottom-custom inputFieldNew"
                                            style="padding-right: 30px !important;"
                                            type="text"
                                            :disabled="field_index > 0 && is_approvers_mandatory"
                                            v-model="td.answer"
                                            maxlength="100"
                                            placeholder="Enter Short Answer"
                                            :name="'short_answer'+ i + '' +  field_index"
                                            v-validate="td.required ? 'required' : ''"
                                            data-vv-as="Short Answer"
                                            />
                                            <!-- API Call Dropdown -->
                                            <div v-if="ticketType.name == 'Digicollect Product Template'">
                                                <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                    v-model="td.answer"
                                                    class="diginew-multiselect border-bottom-custom mt-3"
                                                    :loading="apicall_loading"
                                                    :options="scm_products_options"
                                                    :disabled="field_index > 0 && is_approvers_mandatory"
                                                    :searchable="true" style="width: 250px !important"
                                                    :close-on-select="true"
                                                    :name="'apidrop_down'+ i + '' +  field_index"
                                                    track-by="_id"
                                                    @close="insertMultiProductTag(td.answer)"
                                                    :show-labels="false"
                                                    @search-change="searchTemplateApiDD"
                                                    @open="getTemplateApiDD"
                                                    :multiple="false"
                                                    :options-limit="3000"
                                                    :max-height="200"
                                                    v-validate="td.required ? 'required' : ''"
                                                    :clear-on-select="false"
                                                    label="name"
                                                    :internal-search="true"
                                                    :show-no-results="true"
                                                    :hide-selected="false"
                                                    >
                                                        <template slot="placeholder">
                                                            <span class="diginewhelp-multiselect">Select Product</span>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="reachedEndOfApiDD" />
                                                        </template>
                                                        <template slot="noResult">
                                                            <div v-if="scm_products_options.length">
                                                                <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                    <div></div>
                                                                    <div></div>
                                                                    <div></div>
                                                                    <div></div>
                                                                </div>
                                                            </div>
                                                            <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                </multiselect>
                                            </div>
                                            <div v-else>
                                                <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                                    v-model="td.answer"
                                                    class="diginew-multiselect border-bottom-custom mt-3"
                                                    :loading="apicall_loading"
                                                    :options="scm_products_options"
                                                    :searchable="true" style="width: 250px !important"
                                                    :disabled="field_index > 0 && is_approvers_mandatory"
                                                    :close-on-select="true"
                                                    :name="'apidrop_down'+ i + '' +  field_index"
                                                    :show-labels="false"
                                                    @search-change="searchApiDD"
                                                    @open="getApiDD"
                                                    @close="insertMultiProductTag(td.answer)"
                                                    :multiple="false"
                                                    :options-limit="3000"
                                                    :max-height="200"
                                                    v-validate="td.required ? 'required' : ''"
                                                    :clear-on-select="false"
                                                    label="name"
                                                    :internal-search="true"
                                                    :show-no-results="true"
                                                    :hide-selected="false"
                                                    >
                                                        <template slot="placeholder">
                                                            <span class="diginewhelp-multiselect">Select Product</span>
                                                        </template>
                                                        <template slot="afterList">
                                                            <div v-observe-visibility="reachedEndOfApiDD" />
                                                        </template>
                                                        <template slot="noResult">
                                                            <div v-if="scm_products_options.length">
                                                                <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                                    <div></div>
                                                                    <div></div>
                                                                    <div></div>
                                                                    <div></div>
                                                                </div>
                                                            </div>
                                                            <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                        </template>
                                                </multiselect>
                                            </div>
                                            <!-- Tags -->
                                            <div v-if="td.type == 'tag'">
                                                <vue-tags-input :name="'tags'+  i + '' +  field_index"
                                                data-vv-as="Tags" v-model="td.entered_tag" v-validate="td.required && td.answer.length == 0 ? 'required' : ''" 
                                                class="multi_part-sec border-bottom-custom inputFieldNew-tags create-edit-ticket-tags rel-x2 mt-3" :tags="td.answer" :disabled="field_index > 0 && is_approvers_mandatory"
                                                @tags-changed="tagsChangeMultiData($event, field_index, i, 'by-field')" maxlength="40" 
                                                :placeholder="ticketType.name == 'Digicollect Product Template' || ticketType.name == 'Product Bug Template' ? 'Add Custom Tags' : 'Enter Tags Here'" 
                                                id='to_email' :delete-on-backspace="false" />
                                            </div>
                                            <!-- Radiobutton -->
                                            <el-radio-group 
                                                v-if="td.type == 'radio_button'" class="mt-5 mob-issue-fix w-100" v-model="td.answer" 
                                                v-validate="td.required ? 'required' : ''" :name="'radio_button'+ i + '' +  field_index" 
                                                data-vv-as="Radio Button" :disabled="field_index > 0 && is_approvers_mandatory">
                                                <div class="row">
                                                    <el-radio class="col-xl-2 col-lg-2 col-md-6 col-sm-6 text-capitalize d-flex word-wrap" :label="radio_options" v-for="(radio_options, ri) in td.possible_values" :key="ri">
                                                        {{radio_options}}
                                                    </el-radio>
                                                </div>
                                            </el-radio-group>
                                            <!-- Checkbox -->
                                            <el-checkbox-group 
                                                v-if="td.type == 'check_box'" class="refund-checkbox mt-4 w-100" 
                                                v-model="td.answer" v-validate="td.required ? 'required' : ''" :name="'check_box'+ i + '' +  field_index" 
                                                data-vv-as="Check Box" :disabled="field_index > 0 && is_approvers_mandatory">
                                                <div class="row">
                                                    <el-checkbox class="text-capitalize col-xl-2 col-lg-2 col-md-6 col-sm-6 d-flex word-wrap" :label="check_options" v-for="(check_options, ci) in td.possible_values" :key="ci">
                                                        {{check_options}}
                                                    </el-checkbox>
                                                </div>
                                            </el-checkbox-group>
                                            <!-- Date -->
                                            <date-picker v-if="td.type == 'date'"
                                                class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor" placeholder="Enter the date"
                                                v-validate="td.required ? 'required' : ''" :disabled="field_index > 0 && is_approvers_mandatory"
                                                :name="'date'+ i + '' +  field_index"
                                                data-vv-as="Date"
                                                value-type="format"
                                                format="MM/DD/YYYY" type="date" lang="en" v-model="td.answer"
                                                style="border:none !important">
                                            </date-picker>
                                            <!-- Time -->
                                            <date-picker v-if="td.type == 'time'"
                                                v-model="td.answer" :disabled="field_index > 0 && is_approvers_mandatory"
                                                format="hh:mm A"
                                                :name="'time'+ i + '' +  field_index"
                                                data-vv-as="Time"
                                                class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon"
                                                type="time"
                                                placeholder="Enter the time"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                @confirm="HandleTimeEventMultiPart($event, field_index, i, 'time')"
                                                :minute-step="1"
                                                confirm
                                                confirm-text="APPLY"
                                                v-validate="td.required ? 'required' : ''"
                                            ></date-picker>
                                            <!-- Date and time -->
                                            <div class="d-flex align-items-center" v-if="td.type == 'date_time'">
                                                <div class="row">
                                                    <date-picker v-if="td.type == 'date_time'"
                                                        class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor col-lg-6 col-md-6 col-sm-12" placeholder="Enter the date"
                                                        v-validate="td.required ? 'required' : ''"
                                                        :name="'date_time'+ i + '' +  field_index"
                                                        data-vv-as="Date" :disabled="field_index > 0 && is_approvers_mandatory"
                                                        value-type="format"
                                                        format="MM/DD/YYYY" type="date" lang="en" v-model="td.date"
                                                        style="border:none !important">
                                                    </date-picker>
                                                    <date-picker v-if="td.type == 'date_time'"
                                                        v-model="td.time"
                                                        format="hh:mm a"
                                                        :name="'date_time'+ i + '' +  field_index"
                                                        data-vv-as="Time"
                                                        class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-disabled date-picker-clock-icon col-lg-6 col-md-6 col-sm-12"
                                                        type="time"
                                                        placeholder="Enter the time"
                                                        lang="en" :disabled="field_index > 0 && is_approvers_mandatory"
                                                        value-type="format"
                                                        :clearable="false"
                                                        :editable="false"
                                                        :minute-step="1"
                                                        confirm
                                                        @confirm="HandleTimeEventMultiPart($event, field_index, i, 'date_time')"
                                                        confirm-text="APPLY"
                                                        v-validate="td.required ? 'required' : ''"
                                                    ></date-picker>
                                                </div>
                                            </div>
                                            <!-- Long Answer -->
                                            <textarea 
                                                placeholder="Enter Long Answer"  maxlength="500" v-validate="td.required ? 'required' : ''" 
                                                :name="'long_answer'+ i + '' +  field_index" :disabled="field_index > 0 && is_approvers_mandatory" data-vv-as="Long Answer" v-if="td.type == 'long_answer'" v-model="td.answer" 
                                                class="desc-textarea mt-3"></textarea>
                                            <!-- Dropdown -->
                                            <multiselect
                                                v-if="td.type == 'drop_down' && td.is_api_call_required == false"
                                                v-validate="td.required ? 'required' : ''" style="width: 250px !important"
                                                class="diginew-multiselect border-bottom-custom mt-3"
                                                :name="'drop_down'+ i + '' +  field_index"
                                                data-vv-as="Drop Down"
                                                v-model="td.answer" :disabled="field_index > 0 && is_approvers_mandatory"
                                                :options="td.possible_values"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                            >
                                                <template slot="placeholder">
                                                    <span class="diginewhelp-multiselect">Select Dropdown</span>
                                                </template>
                                            </multiselect>
                                            <div v-if="td.type == 'location'">
                                                <div class="digi-table-loader d-flex justify-content-center" v-if="location_loader" id="spinner" style="margin: 0 auto;position:absolute">
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                    <div></div>
                                                </div>
                                                <div class="form-group contactGroup pt-0">
                                                    <div class="d-flex align-items-center">
                                                        <div class="form-group gMap" style="position:relative;width:100%;padding-top:1.3rem !important">
                                                            <input class="inputFieldNew overflowing-text mt-0 border-bottom-custom" style="padding-right: 30px !important;" 
                                                            :name="'location' + i + '' +  field_index" type="text" disabled v-model="td.location_details.location_vmodel" 
                                                            placeholder="Enter Location" />
                                                            <div class="d-flex">
                                                                <i class="icon icon-map-marker color-blue" style="position: absolute;right: 5px;bottom: 9px;"></i>
                                                            </div>
                                                        </div>
                                                        <div v-if="field_index > 0 && is_approvers_mandatory" class="gps-logo" :id="'DisableOnClick' + i + field_index" style="opacity: .5;cursor: not-allowed;">
                                                            <i class="icon-crosshairs-gps color-blue" ></i>
                                                        </div>
                                                        <div v-else class="gps-logo pointer" :id="'DisableOnClick' + i + field_index" @click="getMultiPartLocation(field_index ,i)">
                                                            <i class="icon-crosshairs-gps color-blue" ></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="td.statement">
                                                <textarea v-model="td.reason" v-validate="td.required ? 'required' : ''" class="text-reason" 
                                                :name="`reason${i}${field_index}`" style="resize: none;" data-vv-as="Reason" placeholder="Enter a reason"></textarea>
                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has(`reason${i}${field_index}`)">{{errors.first(`reason${i}${field_index}`)}}</span>
                                            </div>
                                            <!-- Multi Part Field Attachments -->
                                            <div class="mt-3" v-if="td.add_attachments">
                                                <span class="fw-500 fs-15px">Attachments</span>
                                                <div class="row mt-4 justify-content-frsm">
                                                    <div class="col-lg-4 col-md-6 col-sm-12 pr-0 p-med-12">
                                                        <div class="browse-box bg-grey-box w-100 text-center" @drop="dropAttachmentMPFieldAttachment($event, field_index, i)" @dragover="dragOverAttachment($event)">
                                                            <img src="https://cdn.digicollect.com/cdn/dc_expense_fe/static/images/menu_icons/upload_icon.svg" width="30" class="pt-10 mx-auto" alt="">
                                                            <div class="fs-14 fw-500 mt-2 text-center">Drag and Drop File</div>
                                                            <div class="fs-14 fw-500 text-center">Or</div>
                                                            <label class="choose-file ml-2 btn-upload" v-if="td.attachments.length < 5">
                                                                <input id="multiple" type="file" @change="uploadMPFieldAttachment($event, field_index, i)" accept=".pdf,.doc,.docx,.csv,.ods,.zip,.xls,image/*">
                                                                Browse
                                                            </label>
                                                            <label class="choose-file ml-2 btn-upload" style="background-color: grey;cursor: not-allowed" v-else>
                                                                Browse
                                                            </label>
                                                        </div>
                                                        <div class="my-3 text-center">Or</div>
                                                        <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;border: solid 0.5px #2071d4;background-color: #fff; height: 80px;">
                                                            <span class="fs-14 position-absolute" style="left: 15px; top: 8px;">Paste Image Here</span>
                                                            <input type="text"
                                                                @paste="handlePasteMultiPart($event, field_index, i)"
                                                                readonly :id="'MultiPart'+field_index+''+i" :name="'MultiPart'+field_index+''+i"
                                                                placeholder="'' Click here and press Ctrl + V to Paste ''"
                                                                @input="handleInput" class="paste-input"
                                                                style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-8 col-md-6 col-sm-12" v-if="td.hasOwnProperty('attachments') && td.attachments.length > 0">
                                                        <div class="row browse-box dotted-grey w-100 text-center" style="overflow: auto;">
                                                            <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment, attachment_index) in td.attachments" :key="attachment_index">
                                                                <div class="d-flex align-items-center mt-2 file-bg">
                                                                    <div class="d-flex align-items-center" style="width:90%">
                                                                        <div>
                                                                            <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                                            <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                            <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                            <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                            <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                                            <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                                            <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                                            <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                                            <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                                            <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/>
                                                                        </div>
                                                                        <div class="col">
                                                                            <div class="d-flex justify-content-between">
                                                                                <el-tooltip :content="attachment.name" placement="top">
                                                                                    <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                        {{attachment.name}}
                                                                                    </div>
                                                                                </el-tooltip>
                                                                            </div>
                                                                            <div v-if="attachment.uploading || attachment.url == undefined">
                                                                                <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                            </div>
                                                                            <div class="d-flex justify-content-between">
                                                                                <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                                                <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                                <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="pointer ml-3" style="width:10%; z-index: 1;" @click="deleteMPFieldAttachment(field_index, i, attachment_index)">
                                                                        <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                        <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url"></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else class="col-lg-8 col-md-6 col-sm-12 pl-0 pl-med-12">
                                                        <div class="browse-box dotted-grey w-100 text-center">
                                                            <div class="no-att-msg"> 
                                                                <span class="fs-20 fw-500">No Attachments Added</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.attachment_error">Attachments for this field is required</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="position-absolute">
                                        <!-- Short Answer Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('short_answer'+ i + '' +  field_index)">{{errors.first('short_answer'+ i + '' +  field_index)}}</span>
                                        <!-- Long Answer Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('long_answer'+ i + '' +  field_index)">{{errors.first('long_answer'+ i + '' +  field_index)}}</span>
                                        <!-- Check box Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('check_box'+ i + '' +  field_index)">{{errors.first('check_box'+ i + '' +  field_index)}}</span>
                                        <!-- Radio check Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('radio_button'+ i + '' +  field_index)">{{errors.first('radio_button'+ i + '' +  field_index)}}</span>
                                        <!-- Drop down Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('drop_down'+ i + '' +  field_index)">{{errors.first('drop_down'+ i + '' +  field_index)}}</span>
                                        <!-- SCM Products Drop down Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('apidrop_down'+ i + '' +  field_index)">The Dropdown Field Is Required</span>
                                        <!-- Tags Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('tags'+ i + '' +  field_index)">{{errors.first('tags'+ i + '' +  field_index)}}</span>
                                        <!-- Date Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date'+ i + '' +  field_index)">{{errors.first('date'+ i + '' +  field_index)}}</span>
                                        <!-- Time Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required && td.answer == ''" v-show="errors.has('time'+ i + '' +  field_index)">{{errors.first('time'+ i + '' +  field_index)}}</span>
                                        <!-- Date And Time Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required && td.date == '' && td.time == ''" v-show="errors.has('date_time'+ i + '' +  field_index)">The Date and Time field required</span>
                                        <!-- Location Validations -->
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.error && td.location_details.location_vmodel == ''">The Location field is required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="general-section pt-2 pb-6 mt-4 d-flex justify-content-center" v-if="(is_approvers_mandatory && field_index == 0) || (!is_approvers_mandatory)">
                                <div class="attachment-bg attachment-bg-new pb-8">
                                    <div class="d-flex justify-content-center mt-4">
                                        <div class="img-upload pl-sm-15 pr-sm-15 pt-3 pb-3 text-center bg-white" @drop="dropAttachment($event, field_index)" @dragover="dragOverAttachment($event)">
                                            <span class="pr-4 hide-on-mob">Drag and Drop Files Here</span>
                                            <span class="pr-4 hide-on-mob" style="font-weight:400 !important;">or</span>
                                            <label class="choose-file ml-2 btn-upload" v-if="field.attach_files.length < 10">
                                                <input id="multiple" type="file" @change="uploadAttachmentByPart($event, field_index)" accept=".pdf,.doc,.docx,.csv,.ods,.zip,.xls,image/*">
                                                Browse Files
                                            </label>
                                            <label class="choose-file ml-2 cursor-notallowed btn-upload-disabled" v-else>
                                                Browse Files
                                            </label>
                                            <span class="pr-4 pl-4" style="font-weight:400 !important;">or</span>
                                            <span class="pr-4 pointer">
                                                <img width="50" @click="openCaptureImageMulti(field_index)" src="/static/images/camera.svg" alt="Capture Image" v-if="field.attach_files.length < 10"/>
                                                <img width="50" class="cursor-notallowed" style="opacity:.5 !important" src="/static/images/camera.svg" alt="Capture Image"  v-else/>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="my-3 text-center">Or</div>
                                    <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;border: solid 0.5px #2071d4;background-color: #fff; height: 80px;">
                                        <span class="fs-14 position-absolute" style="left: 15px; top: 8px;">Paste Image Here</span>
                                        <input type="text"
                                            @paste="handlePasteByPart($event, field_index)"
                                            readonly :id="'ByPart'+field_index" :name="'ByPart'+field_index"
                                            placeholder="'' Click here and press Ctrl + V to Paste ''"
                                            @input="handleInput" class="paste-input"
                                            style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;"
                                        />
                                    </div>
                                    <div class="d-flex flex-wrap align-items-center mt-4">
                                        <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in field.attach_files" :key="index">
                                            <div class="d-flex align-items-center mt-6 file-bg">
                                                <div class="d-flex align-items-center" style="width:90%">
                                                    <div>
                                                        <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                        <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                        <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                        <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                        <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                        <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                        <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                        <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                        <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                        <img v-else-if="attachment.name.endsWith('.mp3')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" style="width:40px; height:40px"/>
                                                        <img v-else-if="attachment.name.endsWith('.mp4')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" style="width:40px; height:40px"/>
                                                        <img v-else-if="attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" style="width:40px; height:40px"/>
                                                        <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/>
                                                        <!-- <img v-else-if="attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')"  src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" style="width:40px; height:40px"/> -->
                                                    </div>
                                                    <div class="col">
                                                        <div class="d-flex justify-content-between">
                                                            <el-tooltip :content="attachment.name" placement="top">
                                                                <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                    {{attachment.name}}
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div v-if="attachment.uploading || attachment.url == undefined">
                                                            <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                        </div>
                                                        <div class="d-flex justify-content-between">
                                                            <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                            <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                            <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="pointer ml-3" style="width:10%" @click="deleteAttachmentByPart(attachment,field_index)">
                                                    <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                    <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url && attachment.uploading == false"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <modal
                                        transition="nice-modal-fade"
                                        class="new-modal-default emergency-contact-list"
                                        :name="`capture-image${field_index}`"
                                        v-if="show_capture_image_multi"
                                        :delay="100"
                                        height="auto"
                                        :width="400"
                                        :adaptive="true" :scrollable="true"
                                    >
                                        <div class="v-modal-content" style="border-radius: 15px;background-color: #ebf3ff !important;">
                                            <div class="v-modal-body">
                                                <div class="v-modal-layout d-flex justify-content-center">
                                                    <div id="app" class="web-camera-container mt-10">
                                                        <div v-show="isCameraOpen && isLoading" >
                                                            <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                                                        </div>
                                                        <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                                            <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                                            <video v-show="!isPhotoTaken" :ref="`camera_capture`" :width="250" :height="250" autoplay></video>
                                                            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="250" :height="250"></canvas>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                                                <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;" @click="hideViewMultiPart(field_index)">CANCEL</a>
                                                <button :disabled="!(isCameraOpen && !isLoading)" v-if="isCameraOpen && !isPhotoTaken" @click="takePhotoMultiPart(field_index)" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                                    Capture
                                                </button>
                                                <button :disabled="!(isCameraOpen && !isLoading)" v-if="isPhotoTaken && isCameraOpen" @click="downloadImageByPart(field_index)" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                                    Upload
                                                </button>
                                            </div>
                                        </div>
                                    </modal>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="template_details.length > 0 && template_type == 'default'">
                        <div class="col-lg-12 col-md-12 col-sm-12 mt-5" v-for="(td, i) in template_details" :key='i'>
                            <div class="d-flex flex-column justify-content-start" style="box-shadow: 0 0 2px 0 #939393;border: solid 0.3px #6c6d6f;border-radius: 6px !important;padding: 10px">
                                <div class="fw-600 pt-2 pb-2 fs-13 text-black d-inline-block w-100 overflowing-text" :title="td.name">{{td.name.split('').length > 1 ?  td.name[0].toUpperCase() +''+ td.name.slice(1,) : td.name[0].toUpperCase()}}<span class="text-danger" v-if="td.required == true"> *</span></div>
                                <div>
                                    <!-- Short Answer -->
                                    <input v-if="td.type == 'short_answer'"
                                    class="border-bottom-custom inputFieldNew"
                                    style="padding-right: 30px !important;"
                                    type="text"
                                    v-model="td.answer"
                                    maxlength="100"
                                    placeholder="Enter Short Answer"
                                    :name="'short_answer'+ i"
                                    v-validate="td.required ? 'required' : ''"
                                    data-vv-as="Short Answer"
                                    />

                                    <!-- API Call Dropdown -->
                                    <div v-if="ticketType.name == 'Digicollect Product Template'">
                                        <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                            v-model="td.answer" style="max-width:250px !important"
                                            class="diginew-multiselect border-bottom-custom mt-3"
                                            :loading="apicall_loading"
                                            :options="scm_products_options"
                                            :searchable="true"
                                            :close-on-select="true"
                                            :name="'apidrop_down'+ i"
                                            track-by="_id"
                                            @close="insertProductTag(td.answer)"
                                            :show-labels="false"
                                            @search-change="searchTemplateApiDD"
                                            @open="getTemplateApiDD"
                                            :multiple="false"
                                            :options-limit="3000"
                                            :max-height="200"
                                            v-validate="td.required ? 'required' : ''"
                                            :clear-on-select="false"
                                            label="name"
                                            :internal-search="true"
                                            :show-no-results="true"
                                            :hide-selected="false"
                                            >
                                                <template slot="placeholder">
                                                    <span class="diginewhelp-multiselect">Select Product</span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfApiDD" />
                                                </template>
                                                <template slot="noResult">
                                                    <div v-if="scm_products_options.length">
                                                        <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                    <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                        </multiselect>
                                    </div>
                                    <div v-else>
                                        <multiselect v-if="td.type == 'drop_down' && td.is_api_call_required == true"
                                            v-model="td.answer"
                                            style="max-width:250px !important"
                                            class="diginew-multiselect border-bottom-custom mt-3"
                                            :loading="apicall_loading"
                                            :options="scm_products_options"
                                            :searchable="true"
                                            :close-on-select="true"
                                            :name="'apidrop_down'+ i"
                                            :show-labels="false"
                                            @search-change="searchApiDD"
                                            @open="getApiDD"
                                            @close="insertProductTag(td.answer)"
                                            :multiple="false"
                                            :options-limit="3000"
                                            :max-height="200"
                                            v-validate="td.required ? 'required' : ''"
                                            :clear-on-select="false"
                                            label="name"
                                            :internal-search="true"
                                            :show-no-results="true"
                                            :hide-selected="false"
                                            >
                                                <template slot="placeholder">
                                                    <span class="diginewhelp-multiselect">Select Product</span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfApiDD" />
                                                </template>
                                                <template slot="noResult">
                                                    <div v-if="scm_products_options.length">
                                                        <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                    <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                        </multiselect>
                                    </div>
                                    <!-- Tags -->
                                    <div v-if="td.type == 'tag'">
                                        <vue-tags-input :name="'tags'+ i"
                                        data-vv-as="Tags" v-model="td.entered_tag" v-validate="td.required && td.answer.length == 0 ? 'required' : ''" class="multi_part-sec border-bottom-custom inputFieldNew-tags create-edit-ticket-tags rel-x2 mt-3" :tags="td.answer" @tags-changed="tagsChangeData($event, i, 'by-field')" maxlength="40" :placeholder="ticketType.name == 'Digicollect Product Template' || ticketType.name == 'Product Bug Template' ? 'Add Custom Tags' : 'Enter Tags Here'" id='to_email' :delete-on-backspace="false" />
                                    </div>
                                    <!-- Radiobutton -->
                                    <el-radio-group v-if="td.type == 'radio_button'" class="mt-5 mob-issue-fix w-100" v-model="td.answer" v-validate="td.required ? 'required' : ''" :name="'radio_button'+ i" data-vv-as="Radio Button">
                                        <div class="row">
                                            <el-radio class="col-xl-2 col-lg-2 col-md-3 col-sm-6 text-capitalize d-flex word-wrap" :label="radio_options" v-for="(radio_options, ri) in td.possible_values" :key="ri">
                                                {{radio_options}}
                                            </el-radio>
                                        </div>
                                    </el-radio-group>
                                    <!-- Checkbox -->
                                    <el-checkbox-group v-if="td.type == 'check_box'" class="refund-checkbox mt-4  w-100" v-validate="td.required ? 'required' : ''" :name="'check_box'+ i" data-vv-as="Check Box" v-model="td.answer">
                                        <div class="row">
                                            <!-- <div> -->
                                                <el-checkbox class="text-capitalize col-xl-2 col-lg-2 col-md-3 col-sm-6 d-flex word-wrap" :label="check_options" v-for="(check_options, ci) in td.possible_values" :key="ci">
                                                    {{check_options}}
                                                </el-checkbox>
                                            <!-- </div> -->
                                        </div>
                                    </el-checkbox-group>
                                    <!-- Date -->
                                    <date-picker v-if="td.type == 'date'"
                                    class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor" placeholder="Enter the date"
                                        v-validate="td.required ? 'required' : ''"
                                        :name="'date'+ i"
                                        data-vv-as="Date"
                                        value-type="format"
                                        format="MM/DD/YYYY" type="date" lang="en" v-model="td.answer"
                                        style="border:none !important">
                                    </date-picker>
                                    <!-- Time -->
                                    <date-picker v-if="td.type == 'time'"
                                        v-model="td.answer"
                                        format="hh:mm A"
                                        :name="'time'+ i"
                                        data-vv-as="Time"
                                        class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon"
                                        type="time"
                                        placeholder="Enter the time"
                                        lang="en"
                                        value-type="format"
                                        :clearable="false"
                                        :editable="false"
                                        :minute-step="1"
                                        @confirm="HandleTimeEvent($event, i, 'time')"
                                        confirm
                                        confirm-text="APPLY"
                                        v-validate="td.required ? 'required' : ''"
                                    ></date-picker>
                                    <!-- Date and time -->
                                    <div class="d-flex align-items-center" v-if="td.type == 'date_time'">
                                        <div class="row">
                                            <date-picker v-if="td.type == 'date_time'"
                                                class="inputFieldNew-border-bottom ctet-page date-picker-disabled view-page-cursor col-lg-6 col-md-6 col-sm-12" placeholder="Enter the date"
                                                v-validate="td.required ? 'required' : ''"
                                                :name="'date_time'+ i"
                                                data-vv-as="Date"
                                                value-type="format"
                                                format="MM/DD/YYYY" type="date" lang="en" v-model="td.date"
                                                style="border:none !important">
                                            </date-picker>
                                            <date-picker v-if="td.type == 'date_time'"
                                                v-model="td.time"
                                                format="hh:mm A"
                                                :name="'date_time'+ i"
                                                data-vv-as="Time"
                                                class="new-time-picker new-time-picker-icon view-page-cursor input-field-underline date-picker-clock-icon col-lg-6 col-md-6 col-sm-12"
                                                type="time"
                                                placeholder="Enter the time"
                                                lang="en"
                                                value-type="format"
                                                :clearable="false"
                                                :editable="false"
                                                :minute-step="1"
                                                @confirm="HandleTimeEvent($event, i, 'date_time')"
                                                confirm
                                                confirm-text="APPLY"
                                                v-validate="td.required ? 'required' : ''"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <!-- Long Answer -->
                                    <textarea placeholder="Enter Long Answer"  maxlength="500" v-validate="td.required ? 'required' : ''" :name="'long_answer'+ i" data-vv-as="Long Answer" v-if="td.type == 'long_answer'" v-model="td.answer" class="desc-textarea mt-3"></textarea>
                                    <!-- Dropdown -->
                                    <multiselect
                                        v-if="td.type == 'drop_down' && td.is_api_call_required == false"
                                        v-validate="td.required ? 'required' : ''"
                                        class="diginew-multiselect border-bottom-custom mt-3"
                                        :name="'drop_down'+ i" style="width: 250px !important"
                                        data-vv-as="Drop Down"
                                        v-model="td.answer"
                                        :options="td.possible_values"
                                        :searchable="true"
                                        :close-on-select="true"
                                        :show-labels="false"
                                    >
                                        <template slot="placeholder">
                                            <span class="diginewhelp-multiselect">Select Dropdown</span>
                                        </template>
                                    </multiselect>
                                    <div v-if="td.type == 'location'">
                                        <div class="digi-table-loader d-flex justify-content-center" v-if="location_loader" id="spinner" style="margin: 0 auto;position:absolute;left:40%">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                        <div class="form-group contactGroup pt-0">
                                            <div class="d-flex align-items-center">
                                                <div class="form-group gMap" style="position:relative;width:100%;padding-top:1.3rem !important">
                                                    <input class="inputFieldNew overflowing-text mt-0 border-bottom-custom" style="padding-right: 30px !important;" :name="'location' + i" type="text" disabled v-model="td.location_details.location_vmodel" placeholder="Enter Location" />
                                                    <div class="d-flex">
                                                        <i class="icon icon-map-marker color-blue" style="position: absolute;right: 5px;bottom: 9px;"></i>
                                                    </div>
                                                </div>
                                                <div class="gps-logo pointer" :id="'DisableOnClick' + i" @click="getLocation(i)">
                                                    <i class="icon-crosshairs-gps color-blue" ></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="td.statement">
                                        <textarea v-model="td.reason" v-validate="td.required ? 'required' : ''" class="text-reason" :name="`reason${i}`" style="resize: none;" data-vv-as="Reason" placeholder="Enter a reason"></textarea>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has(`reason${i}`)">{{errors.first(`reason${i}`)}}</span>
                                    </div>
                                    <!-- Default Field Attachments -->
                                    <div class="mt-3" v-if="td.add_attachments">
                                        <span class="fw-500 fs-15px">Attachments</span>
                                        <div class="row mt-4 justify-content-frsm">
                                            <div class="col-lg-4 col-md-6 col-sm-12 pr-0 p-med-12">
                                                <div class="browse-box bg-grey-box w-100 text-center" @drop="dropAttachmentDefaultFieldAttachment($event, i)" @dragover="dragOverAttachment($event)" >
                                                    <img src="https://cdn.digicollect.com/cdn/dc_expense_fe/static/images/menu_icons/upload_icon.svg" width="30" class="pt-10 mx-auto" alt="">
                                                    <div class="fs-14 fw-500 mt-2 text-center">Drag and Drop File</div>
                                                    <div class="fs-14 fw-500 text-center">Or</div>
                                                    <label class="choose-file ml-2 btn-upload" v-if="td.attachments.length < 5">
                                                        <input id="multiple" type="file" @change="uploadDefaultFieldAttachment($event, i)" accept=".pdf,.doc,.docx,.csv,.ods,.zip,.xls,image/*">
                                                        Browse
                                                    </label>
                                                    <label class="choose-file ml-2 btn-upload" style="background-color: grey;cursor: not-allowed" v-else>
                                                        Browse
                                                    </label>
                                                </div>
                                                <div class="my-3 text-center">Or</div>
                                                <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;border: solid 0.5px #2071d4;background-color: #fff; height: 80px;">
                                                    <span class="fs-14 position-absolute" style="left: 15px; top: 8px;">Paste Image Here</span>
                                                    <input type="text"
                                                        @paste="handlePasteDefaultField($event, i)"
                                                        readonly :id="'DefaultField'+i" :name="'DefaultField'+i"
                                                        placeholder="'' Click here and press Ctrl + V to Paste ''"
                                                        @input="handleInput" class="paste-input"
                                                        style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-lg-8 col-md-6 col-sm-12" v-if="td.hasOwnProperty('attachments') && td.attachments.length > 0">
                                                <div class="row browse-box dotted-grey w-100 text-center" style="overflow: auto;">
                                                    <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment, attachment_index) in td.attachments" :key="attachment_index">
                                                        <div class="d-flex align-items-center mt-2 file-bg">
                                                            <div class="d-flex align-items-center" style="width:90%">
                                                                <div>
                                                                    <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                                    <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                                    <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/>
                                                                </div>
                                                                <div class="col">
                                                                    <div class="d-flex justify-content-between">
                                                                        <el-tooltip :content="attachment.name" placement="top">
                                                                            <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                {{attachment.name}}
                                                                            </div>
                                                                        </el-tooltip>
                                                                    </div>
                                                                    <div v-if="attachment.uploading || attachment.url == undefined">
                                                                        <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                                    </div>
                                                                    <div class="d-flex justify-content-between">
                                                                        <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                                        <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                        <div class="fw-500" v-if="attachment.size">({{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}})</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="pointer ml-3" style="width:10%; z-index: 1;" @click="deleteDefaultFieldAttachment(i, attachment_index)">
                                                                <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                                <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else class="col-lg-8 col-md-6 col-sm-12 pl-0 pl-med-12">
                                                <div class="browse-box dotted-grey w-100 text-center">
                                                    <div class="no-att-msg"> 
                                                        <span class="fs-20 fw-500">No Attachments Added</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="invalid-feedback-form text-danger mt-0" v-if="td.attachment_error">Attachments for this field is required</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <!-- Short Answer Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('short_answer'+ i)">{{errors.first('short_answer'+ i)}}</span>
                                <!-- Long Answer Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('long_answer'+ i)">{{errors.first('long_answer'+ i)}}</span>
                                <!-- Check box Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('check_box'+ i)">{{errors.first('check_box'+ i)}}</span>
                                <!-- Radio check Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('radio_button'+ i)">{{errors.first('radio_button'+ i)}}</span>
                                <!-- Drop down Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('drop_down'+ i)">{{errors.first('drop_down'+ i)}}</span>
                                <!-- SCM Products Drop down Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('apidrop_down'+ i)">The Dropdown Field Is Required</span>
                                <!-- Tags Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('tags'+ i)">{{errors.first('tags'+ i)}}</span>
                                <!-- Date Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date'+ i)">{{errors.first('date'+ i)}}</span>
                                <!-- Time Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required && td.answer == ''" v-show="errors.has('time'+ i)">{{errors.first('time'+ i)}}</span>
                                <!-- Date And Time Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.required" v-show="errors.has('date_time'+ i)">The Date and Time field required</span>
                                <!-- Location Validations -->
                                <span class="invalid-feedback-form text-danger mt-0" v-if="td.error && td.location_details.location_vmodel == ''">The Location field is required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="general-section pt-2 pb-6 mt-4 d-flex justify-content-center px-4" v-if="template_type == 'default'">
                    <div class="attachment-bg attachment-bg-new pb-8">
                        <div class="d-flex justify-content-center mt-4" @drop="dropDefaultAttachment($event)" @dragover="dragOverAttachment($event)">
                            <div class="img-upload pl-sm-15 pr-sm-15 pt-3 pb-3 text-center bg-white">
                                <span class="pr-4 hide-on-mob">Drag and Drop Files Here</span>
                                <span class="pr-4 hide-on-mob" style="font-weight:400 !important;">or</span>
                                    <file-upload id="multiple" v-if="attachments.length < 10"
                                        class="choose-file btn btn-new-primary"
                                        :multiple="true"
                                        :size="size || 0"
                                        :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                        :headers="headers"
                                        :add-index="addIndex"
                                        accept=".doc, .docx, .htm, .html, .pdf, .ppt, .pptx, .txt, .Xls, .xlsx, .bmp, .gif, .jpeg, .png, .svg, .tiff, .avi, .flv, .mpg, .mpeg, .mp3, .mp4, .wav, .wmv, .mov.csv,.ods,.zip,"
                                        @input-file="uploadAttachment" ref="upload"
                                        webkitdirectory mozdirectory
                                        style="text-transform: none !important; padding:2px 18px 6px 18px !important;">
                                        Browse Files
                                    </file-upload>
                                    <label class="choose-file ml-2 btn-upload-disabled cursor-notallowed" v-else>
                                        Browse Files
                                    </label>
                                <span class="pr-4 pl-4" style="font-weight:400 !important;">or</span>
                                <span class="pr-4 pointer">
                                    <img width="50" @click="openCaptureImage" src="/static/images/camera.svg" alt="Capture Image" v-if="attachments.length < 10"/>
                                    <img width="50" src="/static/images/camera.svg" class="cursor-notallowed" style="opacity:0.5 !important" alt="Capture Image" v-else/>
                                </span>
                            </div>
                        </div>
                        <div class="my-3 text-center">Or</div>
                        <div class="w-100 d-flex align-items-center justify-content-center position-relative mb-3" style="border-radius: 4px;border: solid 0.5px #2071d4;background-color: #fff; height: 80px;">
                            <span class="fs-14 position-absolute" style="left: 15px; top: 8px;">Paste Image Here</span>
                            <input type="text"
                                @paste="handlePasteDefaultAttachment"
                                readonly :id="'DefaultAttachment'" :name="'DefaultAttachment'"
                                placeholder="'' Click here and press Ctrl + V to Paste ''"
                                @input="handleInput" class="paste-input"
                                style="border: 0 none; outline: 0 none; min-height: 50px; padding: 10px; width: 300px; cursor: pointer !important;"
                            />
                        </div>
                        <div class="d-flex flex-wrap align-items-center mt-4">
                            <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in attachments" :key="index">
                                <div class="d-flex align-items-center mt-6 file-bg">
                                    <div class="d-flex align-items-center" style="width:90%">
                                        <div>
                                            <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                            <img v-else-if="attachment.name.endsWith('.zip') || attachment.name.endsWith('.ZIP')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/zip-icon.svg">
                                            <img v-else-if="attachment.name.endsWith('.csv') || attachment.name.endsWith('.CSV')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/csv_logo.svg">
                                            <img v-else-if="attachment.name.endsWith('.ODS') || attachment.name.endsWith('.ods')" width="40" height="40" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/ods_logo.svg">
                                            <img v-else-if="attachment.name.endsWith('.png') || attachment.name.endsWith('.PNG')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                            <img v-else-if="attachment.name.endsWith('.jpg') || attachment.name.endsWith('.jpeg') || attachment.name.endsWith('.JPG') || attachment.name.endsWith('.JPEG') || attachment.name.endsWith('.tiff') || attachment.name.endsWith('.tif')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                            <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                            <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                            <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                            <img v-else-if="attachment.name.endsWith('.mp3')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" style="width:40px; height:40px"/>
                                            <img v-else-if="attachment.name.endsWith('.mp4')" src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" style="width:40px; height:40px"/>
                                            <img v-else-if="attachment.name.endsWith('.MOV') || attachment.name.endsWith('.mov')" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_video.svg" style="width:40px; height:40px"/>
                                            <img v-else src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/default_attachment_icon.svg" alt="" style="width:40px; height:40px"/>
                                        </div>
                                        <div class="col">
                                            <div class="d-flex justify-content-between">
                                                <el-tooltip :content="attachment.name" placement="top">
                                                    <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                        {{attachment.name}}
                                                    </div>
                                                </el-tooltip>
                                            </div>
                                            <div v-if="attachment.uploading || attachment.url == undefined">
                                                <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}</div>
                                                <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                <div class="fw-500" v-if="attachment.size">{{(attachment.size * 0.001).toFixed(3) + ' KB' | prettyBytes}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pointer ml-3" style="width:10%" @click="deleteAttachment(attachment,index)">
                                        <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                        <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url && attachment.uploading == false"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <modal
                            transition="nice-modal-fade"
                            class="new-modal-default emergency-contact-list"
                            name="capture-image"
                            v-if="show_capture_image"
                            :delay="100"
                            height="auto"
                            :width="400"
                            :adaptive="true" :scrollable="true"
                        >
                            <div class="v-modal-content" style="border-radius: 15px;background-color: #ebf3ff !important;">
                                <div class="v-modal-body">
                                    <div class="v-modal-layout d-flex justify-content-center">
                                        <div id="app" class="web-camera-container mt-10">
                                            <div v-show="isCameraOpen && isLoading" >
                                                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                                            </div>
                                            <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                                                <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                                                <video v-show="!isPhotoTaken" ref="camera_capture" :width="250" :height="250" autoplay></video>
                                                <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="250" :height="250"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                                    <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;" @click="hideView()">CANCEL</a>
                                    <button :disabled="!(isCameraOpen && !isLoading)" v-if="isCameraOpen && !isPhotoTaken" @click="takePhoto" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                        Capture
                                    </button>
                                    <button :disabled="!(isCameraOpen && !isLoading)" v-if="isPhotoTaken && isCameraOpen" @click="downloadImage" type="button" class="btn btn-success btn-smm text-white ml-4" style="box-shadow: none;">
                                        Upload
                                    </button>
                                </div>
                            </div>
                        </modal>
                    </div>
                </div>
                <div class="d-flex justify-content-center mt-10 mb-3" v-if="generalActive && (template_type == 'default' || template_type == 'multi_part')">
                    <button class="btn btn-danger btn-smm text-white mr-0" style="text-transform: uppercase !important;font-size: 12px !important;border-radius: 5px !important;" 
                        @click="cancel()" :disabled="isUploadingInProgress || load_template || save_loader">
                        Cancel
                    </button>
                    <button v-if="template_type == 'multi_part'" type="button" :disabled="isUploadingInProgress || load_template || save_loader" :class="{'btn-success': is_approvers_mandatory,
                            'btn-secondary':!is_approvers_mandatory, 'text-align-left': save_loader, 'w-140' :is_approvers_mandatory && save_loader, 'w-130' :!is_approvers_mandatory && save_loader}" 
                            class="btn text-white btn-smm ml-3" style="box-shadow: none;border-radius: 5px !important" @click="validateNext()">
                        {{ is_approvers_mandatory ? 'Send for Review' : 'Skip and Next'}}
                        <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:50px" />
                    </button>
                    <button v-else :disabled="isUploadingInProgress || load_template || save_loader" class="btn btn-success text-white btn-smm ml-3" :class="save_loader ? 'w-90 text-align-left' : 'text-center'" style="box-shadow: none;border-radius: 5px !important" @click="validateNext()">
                        {{save_loader ? 'Saving' : 'Save'}}
                        <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:30px" />
                    </button>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import VueTagsInput from "@johmun/vue-tags-input";
import { VueEditor } from "vue2-editor";
import scm from '../mixins/scm.js';
import facility_mgmt from '../mixins/facility_mgmt';
import time_utils from '../mixins/time_utils';
import crm from '../mixins/crm.js';
import ticket from '../mixins/ticket.js';
import { SweetModal } from 'sweet-modal-vue';
import FileUpload from 'vue-upload-component';
import SoftwareBugTemplate from "./SoftwareBugTemplate";
import axios from 'axios';
import {EventBus} from "../eventBus/nav-bar-event.js";
import { debounce } from 'lodash';
export default {
    mixins:[scm,crm,ticket, facility_mgmt, time_utils],
    components:{
        HalfCircleSpinner,
        VueTagsInput,
        VueEditor,
        SweetModal,
        FileUpload,
        SoftwareBugTemplate
    },
    data(){
        return{
            // temp data
            template_name: '',
            templateNamelength: 30,

            template_data: [],
            entered_tag: '',
            load_template: false,
            tags_template: [],
            isVisible: false,
            template_search_key: '',
            ticketName: '',
            ticket_name_options: [],
            model_name: '',
            model_name_options: [],
            model_number: 0,
            radio_select: '',
            date_of_purchase: '',
            time_of_purchase: '',
            ticketTemplateListScrollable: false,
            template_details: [],

            camera_selection: [],
            selected_camera_device: '',
            isPhotoTaken: false,
            isShotPhoto: false,
            isLoading: false,
            isCameraOpen: false,

            show_capture_image: false,
            show_capture_image_multi: false,
            ticket_details_description: '',
            refund_reason: [],
            time_of_purchase: '',
            success_msg:'',
            warning_msg:'',
            behalf:'myself',
            assignedTo:'person',
            subject:'',
            department:'',
            department_options:[],
            assignedCustomer:'',
            assign_options:[],
            ticketType:'',
            ticket_type_options:[],
            ticket_type_count: 0,
            subjectlength:100,
            descriptionlength:1000,
            ajaxCallinprogress:false,
            customer_options:[],
            customer:'',
            vendor_options:[],
            vendor:'',
            vendor_count:0,
            vendor_loading:false,
            vendor_scrollable:false,
            vendor_visible:false,
            branch_count:0,
            branch_loading:false,
            branch_scrollable:false,
            branch_visible:false,
            search_key:'',
            temp_vendor_options:[],
            customer_loading:false,
            customer_count:0,
            temp_customer_options:[],
            customer_scrollable:false,
            cutomer_visible:false,
            viewMore:false,
            authorized_person_id:'',
            authorized_person_name:'',
            authorized_department:'',
            authorized_branch:'',
            authorized_email:'',
            authorized_phone:'',
            ticket_template_type:'',
            temp_assign_options:[],
            assign_loading:false,
            assign_scrollable:false,
            assign_count:0,
            assign_visible:false,
            description:'',
            showDescription:false,
            is_parent_ticket:true,
            parent_ticket_id:'',
            ticket_type_loading:false,
            is_validated:false,
            auto_fill_data:{},
            autoFilled:false,
            max_due_date:'',
            max_due_time:'',
            api_date:'',
            temp_attachments:[],
            accept: '*',
            extensions: '*',
            size: 1024 * 1024 * 10,
            total_file_size: 0,
            multiple: true,
            directory: true,
            drop: true,
            dropDirectory: true,
            addIndex: false,
            thread: 3,
            name: 'file',
            postAction: '/upload/post',
            putAction: '/upload/put',
            headers: {
                'X-Csrf-Token': 'xxxx',
            },
            data: {
                '_csrf_token': 'xxxxxx',
            },
            autoCompress: 1024 * 1024,
            uploadAuto: false,
            isOption: false,
            attachments:[],
            parentTicketDetails:'',
            nameOfTicket:'',
            priority:'',
            date_time_of_purchase:[],
            due_date:'',
            product_id:'',
            machine_hours:[],
            crm_customer_id:'',
            branch_options:[],
            branch_name:'',
            generalActive:true,
            productActive:false,
            jobtypeActive:false,
            tab_active1:true,
            tab_active2:false,
            job_ticket_template: '',
            temp_branch_options:[],
            branch_active: false,
            customer_address:'',
            job_type:'',
            jobTypes:[],
            check_ticket_template_type: '',
            sbr_active: false,
            is_service_ticket: false,
            branch_search: '',
            apicall_loading: false,
            scm_products_options: [],
            scm_products_count: 0,
            isUploadingInProgress:false,
            is_drop:false,
            is_input_data :false,
            temp_location: {
                address:"",
                city:"",
                country:"",
                full_address:"",
                location_vmodel:"",
                state:"",
                street1:"",
                township:"",
                zip_code:""
            },
            template_type: '',

            // Approvers Data
            approvers_data: [],
            approvers_scrollable: false,
            approvers_loading: false,
            approvers_count: 0,
            temp_approvers_options: 0,
            approvers_options: [],
            is_approvers_mandatory: false,
            check_attachments: false,
            location_loader: false,
            save_loader: false,
            limit: 993,
        }
    },
    methods:{
        handleInput() {
          // Reset the image when the user types or deletes content
          // this.imageUrl = '';
        },
        handlePasteMultiPart(event, field_index, index) {
            // Access clipboard data
            const clipboardData = event.clipboardData || window.clipboardData;
            if(this.isUploadingInProgress) {
                this.$toasted.global.error("Please wait. Previous file upload already in progress")
            } else {
                if (clipboardData) {
                    const items = clipboardData.items;

                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        // Check if the item is an image
                        if (item.type.indexOf('image') !== -1) {
                            const blob = item.getAsFile();

                            // Convert the blob to data URL
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onload = (e) => {
                            this.cropSuccessMultiPart(e.target.result, field_index, index)
                            };
                        }
                    }
                }
            }
        },
        handlePasteByPart(event, field_index) {
            // Access clipboard data
            const clipboardData = event.clipboardData || window.clipboardData;
            if(this.isUploadingInProgress) {
                this.$toasted.global.error("Please wait. Previous file upload already in progress")
            } else {
                if (clipboardData) {
                    const items = clipboardData.items;

                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        // Check if the item is an image
                        if (item.type.indexOf('image') !== -1) {
                            const blob = item.getAsFile();

                            // Convert the blob to data URL
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onload = (e) => {
                            this.cropSuccessByPart(e.target.result, field_index)
                            };
                        }
                    }
                }
            }
        },
        handlePasteDefaultField(event, index) {
            // Access clipboard data
            const clipboardData = event.clipboardData || window.clipboardData;
            if(this.isUploadingInProgress) {
                this.$toasted.global.error("Please wait. Previous file upload already in progress")
            } else {
                if (clipboardData) {
                    const items = clipboardData.items;

                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        // Check if the item is an image
                        if (item.type.indexOf('image') !== -1) {
                            const blob = item.getAsFile();

                            // Convert the blob to data URL
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onload = (e) => {
                            this.cropSuccessDefaultField(e.target.result, index)
                            };
                        }
                    }
                }
            }
        },
        handlePasteDefaultAttachment(event) {
            // Access clipboard data
            const clipboardData = event.clipboardData || window.clipboardData;
            if(this.isUploadingInProgress) {
                this.$toasted.global.error("Please wait. Previous file upload already in progress")
            } else {
                if (clipboardData) {
                    const items = clipboardData.items;

                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        // Check if the item is an image
                        if (item.type.indexOf('image') !== -1) {
                            const blob = item.getAsFile();

                            // Convert the blob to data URL
                            const reader = new FileReader();
                            reader.readAsDataURL(blob);
                            reader.onload = (e) => {
                            this.cropSuccessDefaultAttachment(e.target.result)
                            };
                        }
                    }
                }
            }
        },
        blobToFileClipboard(theBlob, fileName){
            //A Blob() is almost a File() - it's just missing the two properties below which we will add
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            const myFile = new File([theBlob], 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png', {
                type: theBlob.type,
            });
            return myFile;
        },
        async cropSuccessMultiPart(imgData, part_index, field_index) {
            const base64 = await fetch(imgData);
            const blob = await base64.blob();
            let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            // file_data  // file format type data of image
            // this.uploadMPFieldAttachment(file_data, field_index, i)
            let contains_duplicates = false
            this.template_details[part_index].parts_data[field_index].attachments.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.template_details[part_index].parts_data[field_index].attachments.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[part_index].parts_data[field_index].attachments.push(attachment)
                    this.getResumableURLFieldAttachment(file_data, this.template_details[part_index].parts_data[field_index].attachments[this.template_details[part_index].parts_data[field_index].attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        async cropSuccessByPart(imgData, index) {
            const base64 = await fetch(imgData);
            const blob = await base64.blob();
            let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            // file_data  // file format type data of image
            // this.uploadAttachmentByPart(file_data, field_index)
            let contains_duplicates = false
            this.template_details[index].attach_files.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[index].attach_files.push(attachment)
                    this.getResumableURLByPart(file_data, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        async cropSuccessDefaultField(imgData, index) {
            const base64 = await fetch(imgData);
            const blob = await base64.blob();
            let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            // file_data  // file format type data of image
            // this.uploadDefaultFieldAttachment(file_data, index)
            let contains_duplicates = false
            this.template_details[index].attachments.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.template_details[index].attachments.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[index].attachments.push(attachment)
                    this.getResumableURLFieldAttachment(file_data, this.template_details[index].attachments[this.template_details[index].attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        async cropSuccessDefaultAttachment(imgData) {
            const base64 = await fetch(imgData);
            const blob = await base64.blob();
            let file_data = this.blobToFileClipboard(blob, 'clipboard_copied_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            // file_data  // file format type data of image
            // this.uploadDefaultFieldAttachment(file_data, index)
            let contains_duplicates = false
            this.attachments.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.attachments.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.attachments.push(attachment)
                    this.getResumableURLFieldAttachment(file_data, this.attachments[this.attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        onTextChange() {
            const quill = this.$refs.editor.quill
            const len = quill.getLength()
            if (len > this.limit) {
            quill.deleteText(this.limit, len);
            }
        },
        HandleTimeEventMultiPart(event, part_index, indx, type){
            if(type == 'date_time'){
                if(event == ''){
                    this.template_details[part_index].parts_data[indx].time = '12:00 am'
                }
            } else if(type == 'time'){
                if(event == ''){
                    this.template_details[part_index].parts_data[indx].answer = '12:00 am'
                }
            }
            this.$forceUpdate()
        },
        HandleTimeEvent(event, indx, type){
            if(type == 'date_time'){
                if(event == ''){
                    this.template_details[indx].time = '12:00 am'
                }
            } else if(type == 'time'){
                if(event == ''){
                    this.template_details[indx].answer = '12:00 am'
                }
            }
            this.$forceUpdate()
        },
        ToggleParts(part){
            if(part.show){
                part.show = false
            } else {
                part.show = true
            }
            this.$forceUpdate();
        },
        removeApprovers(option){
            this.approvers_data.forEach((el,index)=>{
                if(el == option){
                    this.approvers_data.splice(index,1)
                }
            })
        },
        async reachedEndOfApprovers(reached){
            if(reached){
                if(this.approvers_scrollable == false){
                    this.approvers_loading = true
                    let params ={
                        skip:this.approvers_count,
                        limit:10,
                        search_key:''
                    }
                    let response = await this.getUserForTickets(params)
                    this.temp_approvers_options = response.response.assigned_user_details.length;
                    if (response.response.skip == this.approvers_count) {
                        if (this.temp_approvers_options > 0) {
                            let tempFiles = response.response.assigned_user_details;
                            tempFiles.forEach(el => {
                                this.approvers_options.push(el);
                            });
                            this.approvers_count += response.response.assigned_user_details.length;
                            this.approvers_loading = false
                        } else {
                            this.approvers_scrollable = true
                            this.approvers_loading = false
                        }
                    }
                }
            }
        },
        tagsChangeData(update_tag, index, mode){
            if(mode == 'by-field'){
                this.template_details[index].answer = update_tag
            } else if(mode == 'by-function'){
                this.template_details[index].answer=update_tag
                setTimeout(() => {
                    document.querySelector(".ti-tags").setAttribute("id", "fstprod");
                    document.getElementById("fstprod").firstChild.style.pointerEvents = 'none';
                    document.getElementById("fstprod").firstChild.lastChild.style.display = 'none';
                }, 500);
            }
            this.$forceUpdate()
        },
        tagsChangeMultiData(update_tag, part_index, index, mode){
            if(mode == 'by-field'){
                this.template_details[part_index].parts_data[index].answer = update_tag
            } else if(mode == 'by-function'){
                this.template_details[part_index].parts_data[index].answer = update_tag
                setTimeout(() => {
                    document.querySelector(".ti-tags").setAttribute("id", "fstprod");
                    document.getElementById("fstprod").firstChild.style.pointerEvents = 'none';
                    document.getElementById("fstprod").firstChild.lastChild.style.display = 'none';
                }, 500);
            }
            this.$forceUpdate()
        },
        insertProductTag(answer){
            this.template_details.forEach((el, el_index) => {
                if(el.type == "tag" && answer != ''){
                    let temp_ans = [...new Set(el.answer.map(x => x))];
                    temp_ans.shift()
                    temp_ans.unshift({
                        text: answer.name,
                        tiClasses: [
                            "ti-valid"
                        ]
                    })
                    this.tagsChangeData(temp_ans, el_index, 'by-function')
                }
            })
            this.$forceUpdate()
        },
        insertMultiProductTag(answer){
            this.template_details.forEach((x, x_index) => {
                x.parts_data.forEach((el, el_index) => {
                    if(el.type == "tag" && answer != ''){
                        let temp_ans = [...new Set(el.answer.map(x => x))];
                        temp_ans.shift()
                        temp_ans.unshift({
                            text: answer.name,
                            tiClasses: [
                                "ti-valid"
                            ]
                        })
                        this.tagsChangeMultiData(temp_ans, x_index, el_index, 'by-function')
                    }
                })
            })
            this.$forceUpdate()
        },
        updateValue(newTags) {
            this.$emit('updateTags', newTags);
        },
        hideProductTemplate(template_name){
            if(template_name) {
                this.generalActive =false
                this.productActive =false
                this.jobtypeActive =true
                this.job_ticket_template = template_name;
            }else {
                this.generalActive =true
                this.productActive =false
                this.jobtypeActive =false;
                this.tab_active2 = false;
                this.job_ticket_template = template_name;
            }
        },
        setPlace(place,index) {
            let address = place.formatted_address.split(", ");
            this.temp_location['street1'] =
                address[address.length - 6] || "";
            this.temp_location['township'] =
                address[address.length - 4] || "";
            this.temp_location['city'] = address[address.length - 3] || "";
            let statezip = address[address.length - 2]
                ? address[address.length - 2].split(" ")
                : ["", ""];
            if (statezip.length == 1) {
                if (statezip[0].match(/^[0-9]+$/)) {
                this.temp_location['zip_code'] = statezip[0];
                } else {
                this.temp_location['state'] = statezip[0];
                }
            } else {
                this.temp_location['zip_code'] = statezip[0].match(/^[0-9]+$/)
                ? statezip[0]
                : statezip[1].match(/^[0-9]+$/)
                ? statezip[1]
                : "";
                this.temp_location['state'] = statezip[0].match(/^[a-zA-Z]+$/)
                ? statezip[0]
                : statezip[1].match(/^[a-zA-Z]+$/)
                ? statezip[1]
                : "";
            }
            if (address[address.length - 1].includes("-")) {
                let countrySelected = address[address.length - 1].split(" - ");
                countrySelected.forEach(x => {
                if (this.countries.includes(x)) {
                        this.temp_location['country'] = x;
                } else {
                        this.temp_location['country'] = "";
                }
                });
            } else {
                this.temp_location['country'] = address[address.length - 1];
            }
            this.temp_location['location_vmodel'] = place.formatted_address;
            this.temp_location['full_address'] = place.formatted_address;
            this.template_details[index].location_details = this.temp_location
            this.$forceUpdate();
        },
        getLocation(index) {
            // this.addressIndex = index;
            if (navigator.geolocation) {
                this.location_loader = true
                // timeout at 60000 milliseconds (60 seconds)
                var options = {
                    enableHighAccuracy: false,
                    timeout: 30000, // milliseconds (30 seconds)
                    maximumAge: 600000
                }; // milliseconds (10 minutes)
                navigator.geolocation.getCurrentPosition(
                    this.showLocation,
                    this.errorHandler,
                    this.assignLocationDetails(index),
                    options
                );
            } else {
                alert("Sorry, browser does not support geolocation!");
            }
            document.getElementById('DisableOnClick' + index).style.pointerEvents = 'none';
        },
        getMultiPartLocation(part_index, field_index){
            if (navigator.geolocation) {
                this.location_loader = true
                // timeout at 60000 milliseconds (60 seconds)
                var options = {
                    enableHighAccuracy: false,
                    timeout: 30000, // milliseconds (30 seconds)
                    maximumAge: 600000
                }; // milliseconds (10 minutes)
                navigator.geolocation.getCurrentPosition(
                    this.showLocation,
                    this.errorHandler,
                    this.assignMultiLocationDetails(part_index, field_index),
                    options
                );
            } else {
                alert("Sorry, browser does not support geolocation!");
            }
            document.getElementById('DisableOnClick' + field_index + part_index).style.pointerEvents = 'none';
        },
        assignLocationDetails(index){
            this.template_details[index].location_details = this.temp_location
        },
        assignMultiLocationDetails(part_index, field_index){
            this.template_details[part_index].parts_data[field_index].location_details = this.temp_location
        },
        showLocation(position) {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
            let calllatlong = axios.create();
            delete calllatlong.defaults.headers.common['Authorization'];
            calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue + "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
            .then(response => {
                let address = response.data.results[0].formatted_address.split(", ");
                this.temp_location['street1'] =
                address[address.length - 6] || "";
                this.temp_location['township'] =
                address[address.length - 4] || "";
                this.temp_location['city'] = address[address.length - 3] || "";
                let statezip = address[address.length - 2]
                ? address[address.length - 2].split(" ")
                : ["", ""];
                this.temp_location['zip_code'] = statezip[0].match(/^[0-9]+$/)
                ? statezip[0]
                : statezip[1].match(/^[0-9]+$/)
                ? statezip[1]
                : "";
                this.temp_location['state'] = statezip[0].match(/^[a-zA-Z]+$/)
                ? statezip[0]
                : statezip[1].match(/^[a-zA-Z]+$/)
                ? statezip[1]
                : "";
                if (address[address.length - 1].includes("-")) {
                let countrySelected = address[address.length - 1].split(" - ");
                countrySelected.forEach(x => {
                        if (this.countries.includes(x)) {
                        this.temp_location['country'] = x;
                        } else {
                        this.temp_location['country'] = "";
                        }
                });
                } else {
                this.temp_location['country'] = address[address.length - 1];
                }
                this.temp_location['location_vmodel'] = response.data.results[0].formatted_address;
                this.temp_location['full_address'] = response.data.results[0].formatted_address;
                this.location_loader = false
                this.$forceUpdate();
            })
            .catch(e => {
                // this.errors.push(e)
            });
        },
        errorHandler(err) {
            if (err.code == 1) {
                alert("Please Allow Location Access");
            } else if (err.code == 2) {
                alert("Error: Position is unavailable!");
            }
        },
        hideSBR() {
            this.generalActive = true
            this.sbr_active = false
        },
        hideFinalTemplate() {
            if(this.$route.params.id) {
                this.jobtypeActive =false
                this.productActive =false
                this.generalActive =true
            }
            else {
                this.jobtypeActive =false
                this.productActive =true
                this.generalActive =false
            }
            this.job_ticket_template = '';
        },
        dragOverAttachment(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
        },
        dropAttachment(evt, index) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                this.uploadFromDrop(file, index)
            });
        },
        uploadFromDrop(event, index) {
            let contains_duplicates = false
            this.template_details[index].attach_files.forEach((e) => {
                if(e.name == event.name){
                    contains_duplicates = true
                }
            })
            if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
                if(event) {
                    var input = event;
                }
                if (input && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        //id: uuidv4(),
                        name: input.name,
                        size: JSON.stringify(input.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    if(this.template_details[index].attach_files.length < 10){
                        this.template_details[index].attach_files.push(attachment)
                        this.getResumableURLByPart(input, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
                    } else {
                        this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                    }
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        inputFile(newFile, oldFile) {
            this.temp_attachments = []
            if (newFile && oldFile) {
                if (newFile.active && !oldFile.active) {
                if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                    this.$refs.upload.update(newFile, { error: 'size' })
                }
                }
                if (newFile.progress !== oldFile.progress) {
                }
                if (newFile.error && !oldFile.error) {
                }
                if (newFile.success && !oldFile.success) {
                }
            }
            if (!newFile && oldFile) {
                if (oldFile.success && oldFile.response.id) {
                }
            }
            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                if (this.uploadAuto && !this.$refs.upload.active) {
                this.$refs.upload.active = true
                }
            }
            this.input_file = newFile
            this.uploadAttachment()
        },
        uploadAttachmentByPart(event, index){
            if(event) {
                var input = event.target;
            }
            if(event == undefined) {
                var input 
                input = this.$refs.upload.files
                let contains_duplicates = false
                this.template_details[index].attach_files.forEach((e) => {
                    if(e.name == input[0].file.name){
                        contains_duplicates = true
                    }
                })
                if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
                    input['files'] = []
                    input.files.push({
                        lastModified : input[0].file.lastModified,
                        name : input[0].file.name,
                        size : input[0].file.size,
                        type : input[0].file.type,
                        webkitRelativePath : input[0].file.webkitRelativePath,
                        lastModifiedDate : input[0].file.lastModifiedDate
                    })
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                        url:""
                    }
                    this.template_details[index].attach_files.push(attachment)
                    this.getResumableURLByPart(input[0].file, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
                } else if(contains_duplicates){
                    this.$toasted.global.error("This file is already uploaded")
                }else {
                    this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                }
            }
            if (input.files && input.files[0] && event) {
                let contains_duplicates = false
                this.template_details[index].attach_files.forEach((e) => {
                    if(e.name == input.files[0].name){
                        contains_duplicates = true
                    }
                })
                if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[index].attach_files.push(attachment)
                    this.getResumableURLByPart(input.files[0], this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
                } else if(contains_duplicates){
                    this.$toasted.global.error("This file is already uploaded")
                } else {
                    this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
                }
            }
        },
        getResumableURLByPart(file, attachment) {
            this.isUploadingInProgress = true;
            let usage_type = {
                usage: "attachment"
            } 
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                delete attachment['source'];
                if (response.data.hasOwnProperty('reason')){
                    attachment.error = "Error Uploading"
                    if (attachment.url == undefined) {
                        this.check_attachments = true
                    } else {
                        this.check_attachments = false
                    }
                }
            })
            .catch(error => {
            })
        },
        uploadAttachment(newFile,oldFile) {
            let contains_duplicates = false
            this.attachments.forEach((e) => {
                if(e.name == newFile.name){
                    contains_duplicates = true
                }
            })
            if(this.attachments.length < 10 && !contains_duplicates){
                var input = newFile;
                this.total_file_size = this.total_file_size + input.file.size
                if (input.file) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.file.name,
                        size: JSON.stringify(input.file.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.attachments.push(attachment);
                    this.getResumable(input.file, this.attachments[this.attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        getResumable(file, attachment) {
            this.isUploadingInProgress = true;
            attachment.uploading = true;
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file', file)
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent
                        .total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                delete attachment['source'];
                setTimeout(() => {
                    // this.saveFiles();
                }, 500);
            })
            .catch(error => {
                // console.log(error.data.reason)
            })
        },
        deleteAttachment(attachment,index){
            this.attachments.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.attachments.splice(elindex,1)
                }
            })
        },
        deleteAttachmentByPart(attachment,part_index){
            this.template_details[part_index].attach_files.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.template_details[part_index].attach_files.splice(elindex,1)
                }
            })
            this.$forceUpdate()
        },
        deleteMPFieldAttachment(part_index, field_index, attachment_index){
            this.template_details[part_index].parts_data[field_index].attachments.splice(attachment_index, 1)
            this.$forceUpdate()
        },
        deleteDefaultFieldAttachment(index, attachment_index){
            this.template_details[index].attachments.splice(attachment_index, 1)
            this.$forceUpdate()
        },
        goToListView() {
            this.$router.push({
                name: 'TicketsList',
            })
        },
        cancel(){
            this.$router.push({
                name: 'TicketsList',
            })
        },
        validateNext(){
            if(this.template_type == 'default'){
                let check_errors = []
                this.template_details.forEach((template, template_index) => {
                    if(template.type == 'location' && template.required == true && template.location_details.location_vmodel == ''){
                        template.error = true
                    } else {
                        template.error = false
                    }
                    if(template.add_attachments && template.hasOwnProperty('attachments')){
                        if(template.required == true && template.attachments.length == 0){
                            check_errors.push(true)
                            template.attachment_error = true
                        } else {
                            check_errors.push(false)
                            template.attachment_error = false
                        }
                    }
                })
                this.$validator.validateAll().then(result => {
                    if (result == true && this.attachments.length <= 10 && this.template_details.every(this.checkError) && check_errors.every(x => x == false)){
                        this.attachments.forEach(attachment => {
                            delete attachment['created_time']
                            delete attachment['error']
                            delete attachment['id'];
                            delete attachment['progress']
                            // delete attachment['size']
                            delete attachment['uploading']
                        })
                        localStorage.setItem("ticketDetails", JSON.stringify(this.create_json));
                        let created_data = JSON.parse(localStorage.getItem('ticketDetails'));
                        created_data.template_data.forEach((template, index) => {
                            if(template.type == 'date_time'){
                                template.answer = template.date + ' ' + template.time
                                delete template.date
                                delete template.time
                            }
                            if(template.type == 'tag'){
                                template.answer.forEach((ti, ti_index) => {
                                    delete ti['tiClasses']
                                    template.answer[ti_index] = ti.text
                                })
                                delete template.entered_tag
                            }
                            if(template.type == 'drop_down' && template.is_api_call_required == true){
                                template.product = template.answer['_id']
                                delete template.answer['category']
                                delete template.answer['description']
                                delete template.answer['item_code']
                                delete template.answer['sub_category']
                                delete template.answer['variant_id']
                                delete template.answer['_id']
                                delete template.answer['name']
                                template.answer = template.product
                                delete template.product
                            }
                            if(template.type == 'location'){
                                template.answer = template.location_details.location_vmodel
                                delete template.location_details
                                delete template.error
                            }
                            if(template.type == 'check_box' || template.type == 'radio_button' || template.type == 'drop_down'){
                                delete template['possible_values']
                                if(template.hasOwnProperty('statement')){
                                    delete template.statement
                                }
                            }
                            if(template.add_attachments && template.hasOwnProperty('attachments')){
                                template.attachments.forEach((e) => {
                                    delete e['created_time']
                                    delete e['error']
                                    delete e['progress']
                                    // delete e['size']
                                    delete e['uploading']
                                })
                            }
                            delete template['add_attachments']
                            delete template['attachment_error']
                            delete template['is_api_call_required']
                            delete template['required']
                            delete template['type']
                            delete template['error']
                        })
                        try{
                            this.addNewTicket(created_data)
                        } catch(error) {
                        }
                    }
                    else if(this.attachments.length > 10){
                        this.$toasted.global.error("10 Attachments are Allowed")
                    }else{
                        this.$toasted.global.error("Please Fill All The Required Fields")
                    }
                })
            } else {
                let check_errors = []
                if (this.is_approvers_mandatory) {
                    this.template_details.forEach((template, template_index) => {
                        template.parts_data.forEach((x, i) => {
                            if(this.is_approvers_mandatory){
                                if(x.type == 'location' && x.required == true && x.location_details.location_vmodel == '' && template_index == 0){
                                    check_errors.push(true)
                                    x.error = true
                                } else {
                                    check_errors.push(false)
                                    x.error = false
                                }
                            } else {
                                if(x.type == 'location' && x.required == true && x.location_details.location_vmodel == ''){
                                    check_errors.push(true)
                                    x.error = true
                                } else {
                                    check_errors.push(false)
                                    x.error = false
                                }
                            }
                            if(x.add_attachments && x.hasOwnProperty('attachments')){
                                if(x.required == true && x.attachments.length == 0){
                                    check_errors.push(true)
                                    x.attachment_error = true
                                } else {
                                    check_errors.push(false)
                                    x.attachment_error = false
                                }
                            }
                        })
                    })
                } else {
                    this.template_details.forEach((template, template_index) => {
                        template.parts_data.forEach((x, i) => {
                            if(x.type == 'location' && x.required == true && x.location_details.location_vmodel == ''){
                                check_errors.push(true)
                                x.error = true
                            } else {
                                check_errors.push(false)
                                x.error = false
                            }
                            if(x.add_attachments && x.hasOwnProperty('attachments')){
                                if(x.required == true && x.attachments.length == 0){
                                    check_errors.push(true)
                                    x.attachment_error = true
                                } else {
                                    check_errors.push(false)
                                    x.attachment_error = false
                                }
                            }
                        })
                    })
                }
                this.$validator.validateAll().then(result => {
                    if (result == true && this.attachments.length <= 10 && check_errors.every(x => x == false)){
                        this.attachments.forEach(attachment => {
                            delete attachment['created_time']
                            delete attachment['error']
                            delete attachment['id'];
                            delete attachment['progress']
                            // delete attachment['size']
                            delete attachment['uploading']
                        })
                        localStorage.setItem("ticketDetails", JSON.stringify(this.create_multi_json));
                        let created_data = JSON.parse(localStorage.getItem('ticketDetails'));
                        created_data.template_data.forEach((template, index) => {
                            delete template.show
                            delete template.statement
                            template.attach_files.forEach((y) => {
                                delete y['created_time']
                                delete y['error']
                                delete y['id'];
                                delete y['progress']
                                // delete y['size']
                                delete y['uploading']
                            })
                            template.parts_data.forEach((y, y_index) => {
                                if(y.type == 'date_time'){
                                    y.answer = y.date + ' ' + y.time
                                    delete y.date
                                    delete y.time
                                }
                                if(y.type == 'tag'){
                                    y.answer.forEach((ti, ti_index) => {
                                        delete ti['tiClasses']
                                        y.answer[ti_index] = ti.text
                                    })
                                    delete y.entered_tag
                                }
                                if(y.type == 'drop_down' && y.is_api_call_required == true){
                                    y.product = y.answer['_id']
                                    delete y.answer['category']
                                    delete y.answer['description']
                                    delete y.answer['item_code']
                                    delete y.answer['sub_category']
                                    delete y.answer['variant_id']
                                    delete y.answer['_id']
                                    delete y.answer['name']
                                    y.answer = y.product
                                    delete y.product
                                }
                                if(y.type == 'location'){
                                    y.answer = y.location_details.location_vmodel
                                    delete y.location_details
                                    delete y.error
                                }
                                if(y.type == 'check_box' || y.type == 'radio_button' || y.type == 'drop_down'){
                                    delete y['possible_values']
                                    if(y.hasOwnProperty('statement')){
                                        delete y.statement
                                    }
                                }
                                if(y.add_attachments && y.hasOwnProperty('attachments')){
                                    y.attachments.forEach((e) => {
                                        delete e['created_time']
                                        delete e['error']
                                        delete e['progress']
                                        // delete e['size']
                                        delete e['uploading']
                                    })
                                }
                                delete y['add_attachments']
                                delete y['attachment_error']
                                delete y['is_api_call_required']
                                delete y['required']
                                delete y['type']
                                delete y['error']
                            })
                        })
                        try{
                            this.addNewTicket(created_data)
                        } catch(error) {
                            console.log(error)
                        }
                    }
                    else if(this.attachments.length > 10){
                        this.$toasted.global.error("10 Attachments are Allowed")
                    }else{
                        this.$toasted.global.error("Please Fill All The Required Fields")
                    }
                })
            }
        },
        checkError(i) {
            return i.error == false;
        },
        async addNewTicket(created_data) {
            try{
                this.save_loader = true
                let response = await this.addTicket(created_data)
                if (response.status_id == 1){
                    this.success_msg = response.response.success_message
                    EventBus.$emit('RecallNotification')
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.save_loader = false
                        EventBus.$emit('RecallNotification')
                        this.$router.push('/ticketdetails/?view_ticket=overall');
                    }, 3000);
                } else if(response.status_id == 0){
                    this.save_loader = false
                    this.warning_msg = response.response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } catch(err) {
                this.save_loader = false
                this.warning_msg = err
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        descriptionShow(){
            if(this.showDescription){
                this.showDescription = false
            }else{
                this.showDescription = true
            }
        },
        clearDescription() {
            this.description = ''
        },
        async getAllAssignToDebouncer(search_key){
            try {
                this.assign_options = []
                this.assign_loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getUserForTickets(params)
                this.assign_options = res.response.assigned_user_details
                this.assign_count = this.temp_assign_options.length
                this.assign_loading = false
                this.assign_scrollable = false
            } catch (reason) {

            }
        },
        async reachedEndOfAssigned(reached){
            this.assign_visible = reached
            if (reached) {
                if (this.assign_scrollable == false) {
                    this.assign_loading = true
                    let params ={
                        skip:this.assign_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserForTickets(params)
                    this.temp_assign_options = response.response.assigned_user_details.length;
                    if (response.response.skip == this.assign_count) {
                        if (this.temp_assign_options > 0) {
                            let tempFiles = response.response.assigned_user_details;
                            tempFiles.forEach(el => {
                                this.assign_options.push(el);
                            });
                            this.assign_count += response.response.assigned_user_details.length;
                            this.assign_loading = false
                        } else {
                            this.assign_scrollable = true
                            this.assign_loading = false
                        }
                    }
                    this.assign_loading = false
                }
            }
        },
        viewMoreClick(){
            if(this.viewMore){
                this.viewMore = false
            }else{
                this.viewMore = true
            }
        },
        behalfChange(value){
            if(value == 'myself'){
                this.authorized_person_name = this.loggedInUser.full_name
                if(this.loggedInUser.department && this.loggedInUser.department.length) this.authorized_department = this.loggedInUser.department[0]
                this.authorized_branch = this.loggedInUser.branch || ''
                this.authorized_email = this.loggedInUser.email
                this.authorized_phone = this.loggedInUser.phone || ''
                this.authorized_person_id = this.loggedInUser.user_id || ''
                this.customer = ''
                this.vendor = ''
                this.$validator.reset();
            }else{
                this.customer = ''
                this.vendor = ''
                this.authorized_person_name = ''
                this.authorized_department = ''
                this.authorized_branch = ''
                this.authorized_email = ''
                this.authorized_phone = ''
                this.$validator.reset();
            }
        },
        assignedToChange(){
            this.assignedCustomer = ''
            this.$validator.reset();
        },
        async getTicketType(){
            try {
                if(this.department && this.department._id){
                    this.ticket_type_loading = true
                    this.ticket_type_options = []
                    let params = {
                        department_id:this.department._id,
                        limit:10,
                        search_key:'',
                        skip:0,
                        ticket_template_type:this.ticket_template_type || 'base'
                    }
                    let res = await this.getTemplateByDept(params)
                    this.ticket_type_options = res.response.all_templates
                    this.ticket_type_loading = false
                }else{
                    this.$toasted.global.error("Please Select Department")
                }
            } catch (reason) {

            }
        },
        async getTicketTemplate(){
            this.ticket_type_loading = true
            try {
                let params = {
                    limit: 10,
                    search_key: '',
                    skip: 0,
                    sort_key: 'name',
                    sort_value: 1
                }
                let response = await this.getDynamicTemplateList(params)
                this.ticket_type_options = response.response.dynamic_details
                this.ticket_type_loading = false
                this.ticketTemplateListScrollable = false
            } catch (error) {
            }
        },

        async reachedEndOfTicketTemplate(reached){
            this.isVisible = reached;
            if (reached) {
                if(this.ticketTemplateListScrollable == false){
                    this.ticket_type_loading = true
                    let response = await this.getDynamicTemplateList({
                        search_key: this.template_search_key,
                        skip: this.ticket_type_count,
                        limit: 10,
                        sort_key: 'name',
                        sort_value: 1
                    })
                    let temp_ticket_template_options = response.response.dynamic_details.length
                    if(response.response.skip == this.ticket_type_count){
                        if(temp_ticket_template_options > 0){
                            let tempfiles = response.response.dynamic_details
                            tempfiles.forEach(el => {
                                this.ticket_type_options.push(el)
                            });
                            this.ticket_type_options = this.ticket_type_options.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.ticket_type_options.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.ticket_type_count += response.response.dynamic_details.length
                            this.ticket_type_loading = false
                        } else {
                            this.ticketTemplateListScrollable = true
                            this.ticket_type_loading = false
                        }
                    }
                    this.ticket_type_loading = false
                }
            }
        },
        async getApiDD(){
            this.apicall_loading = true
            try{
                let params = {
                    limit: 10,
                    search_key: "",
                    skip: 0
                }
                let response = await this.getScmProductsDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async getTemplateApiDD(){
            this.apicall_loading = true
            try{
                let params = {
                    limit: 10,
                    search_key: "",
                    skip: 0
                }
                let response = await this.getProductTemplatesDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async searchApiDDDebouncer(search_key){
            this.apicall_loading = true
            // this.template_search_key = search_key || '';
            try{
                let params = {
                    limit: 10,
                    search_key: search_key,
                    skip: 0
                }
                let response = await this.getScmProductsDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async searchTemplateApiDDDebouncer(search_key){
            this.apicall_loading = true
            // this.template_search_key = search_key || '';
            try{
                let params = {
                    limit: 10,
                    search_key: search_key,
                    skip: 0
                }
                let response = await this.getProductTemplatesDD(params)
                this.scm_products_options = response.response.products
                this.scm_products_count = response.response.products.length
                this.apicall_loading = false
            } catch (error) {
            }
        },
        async searchTemplateDebouncer(search_key){
            this.ticket_type_loading = true
            this.template_search_key = search_key || '';
            try{
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: this.template_search_key,
                    sort_key: 'name',
                    sort_value: 1
                }
                let response = await this.getDynamicTemplateList(params)
                this.ticket_type_options = []
                this.ticket_type_options = response.response.dynamic_details
                this.ticket_type_count = response.response.dynamic_details.length
                this.ticket_type_loading = false
            } catch (error) {
            }
        },
        getTemplateSpace(){
            if(this.template_type == 'multi_part'){
                this.template_details.forEach((x,index) => {
                    if(this.is_approvers_mandatory){
                        if(index == 0){
                            x.show = true
                            x.attach_files = []
                            x.is_send_for_review = this.is_approvers_mandatory
                            x.part_name = x.name
                            x.parts_data = JSON.parse(JSON.stringify(x.fields))
                            x.parts_data.forEach((data, data_index) => {
                                if(data.type == 'check_box' || data.type == 'radio_button') {
                                    data.answer = []
                                    data.error = false
                                    if(data.statement){
                                        data.reason = ''
                                    }
                                }
                                else if(data.type == 'tag'){
                                    data.entered_tag = ''
                                    data.answer = []
                                    data.error = false
                                }
                                else if(data.type == 'dropdown' && data.is_api_call_required == true){
                                    data.answer = ''
                                    data.error = false
                                    if(data.statement){
                                        data.reason = ''
                                    }
                                }
                                else if(data.type == 'drop_down' && data.is_api_call_required == false){
                                    data.answer = ''
                                    data.error = false
                                    if(data.statement){
                                        data.reason = ''
                                    }
                                }
                                else if(data.type == 'date_time'){
                                    data.date = ''
                                    data.time = ''
                                    data.error = false
                                }
                                else if(data.type == 'location'){
                                    data.answer = ''
                                    data.location_details = {
                                        address:"",
                                        city:"",
                                        country:"",
                                        full_address:"",
                                        location_vmodel:"",
                                        state:"",
                                        street1:"",
                                        township:"",
                                        zip_code:""
                                    }
                                    data.error = false
                                }
                                else {
                                    data.answer = ''
                                    data.error = false
                                }
                                if(data.hasOwnProperty('add_attachments') && data.add_attachments){
                                    data.attachments = []
                                    data.attachment_error = false
                                }
                            })
                        } else {
                            x.part_name = x.name
                            x.parts_data = []
                        }
                    } else {
                        x.show = true
                        x.attach_files = []
                        x.is_send_for_review = this.is_approvers_mandatory
                        x.part_name = x.name
                        x.parts_data = JSON.parse(JSON.stringify(x.fields))
                        x.parts_data.forEach((data, data_index) => {
                            if(data.type == 'check_box' || data.type == 'radio_button') {
                                data.answer = []
                                data.error = false
                                if(data.statement){
                                    data.reason = ''
                                }
                            }
                            else if(data.type == 'tag'){
                                data.entered_tag = ''
                                data.answer = []
                                data.error = false
                            }
                            else if(data.type == 'dropdown' && data.is_api_call_required == true){
                                data.answer = ''
                                data.error = false
                                if(data.statement){
                                    data.reason = ''
                                }
                            }
                            else if(data.type == 'drop_down' && data.is_api_call_required == false){
                                data.answer = ''
                                data.error = false
                                if(data.statement){
                                    data.reason = ''
                                }
                            }
                            else if(data.type == 'date_time'){
                                data.date = ''
                                data.time = ''
                                data.error = false
                            }
                            else if(data.type == 'location'){
                                data.answer = ''
                                data.location_details = {
                                    address:"",
                                    city:"",
                                    country:"",
                                    full_address:"",
                                    location_vmodel:"",
                                    state:"",
                                    street1:"",
                                    township:"",
                                    zip_code:""
                                }
                                data.error = false
                            }
                            else {
                                data.answer = ''
                                data.error = false
                            }
                            if(data.hasOwnProperty('add_attachments') && data.add_attachments){
                                data.attachments = []
                                data.attachment_error = false
                            }
                        })
                    }
                    delete x.fields
                    delete x.name
                })
            } else {
                this.template_details.forEach((data,index) => {
                    if(data.type == 'check_box' || data.type == 'radio_button') {
                        this.template_details[index].answer = []
                        this.template_details[index].error = false
                        if(data.statement){
                            data.reason = ''
                        }
                    }
                    else if(data.type == 'tag'){
                        this.template_details[index].entered_tag = ''
                        this.template_details[index].answer = []
                        this.template_details[index].error = false
                    }
                    else if(data.type == 'dropdown' && data.is_api_call_required == true){
                        this.template_details[index].answer = ''
                        this.template_details[index].error = false
                        if(data.statement){
                            data.reason = ''
                        }
                    }
                    else if(data.type == 'drop_down' && data.is_api_call_required == false){
                        data.answer = ''
                        data.error = false
                        if(data.statement){
                            data.reason = ''
                        }
                    }
                    else if(data.type == 'date_time'){
                        this.template_details[index].date = ''
                        this.template_details[index].time = ''
                        this.template_details[index].error = false
                    }
                    else if(data.type == 'location'){
                        this.template_details[index].answer = ''
                        this.template_details[index].location_details = {
                            address:"",
                            city:"",
                            country:"",
                            full_address:"",
                            location_vmodel:"",
                            state:"",
                            street1:"",
                            township:"",
                            zip_code:""
                        }
                        this.template_details[index].error = false
                    }
                    else {
                        this.template_details[index].answer = ''
                        this.template_details[index].error = false
                    }
                    if(data.hasOwnProperty('add_attachments') && data.add_attachments){
                        data.attachments = []
                        data.attachment_error = false
                    }
                })
            }
        },
        async selectedTemplate(data){
            this.load_template = true
            this.save_loader = false
            this.approvers_data = []
            this.is_approvers_mandatory = false
            this.approvers_options = []
            try{
                let params = {
                    dynamic_template_id: data._id
                }
                let response = await this.getDynamicTemplate(params)
                this.template_type = response.response.template_type
                if(this.template_type == 'multi_part'){
                    this.approvers_options = response.response.approve_data
                    if(this.approvers_options.length > 0){
                        this.is_approvers_mandatory = true
                    } else {
                        this.is_approvers_mandatory = false
                    }
                    this.template_details = response.response.multi_parts_data
                    this.assignedTo = 'unassigned'
                } else {
                    this.is_approvers_mandatory = false
                    this.template_details = response.response.fields
                }
                this.getTemplateSpace()
                this.load_template = false
            } catch (error) {
                this.load_template = false
            }
        },
        checkTicketType(){
            if(this.ticketType == null) {
                this.template_details = []
            }
        },
        async getTicketTypeInitial(){
           try {
                this.ajaxCallinprogress = true
                if(this.department && this.department._id){
                    this.ticket_type_options = []
                    let params = {
                        department_id: this.department._id,
                        limit:10,
                        search_key:'',
                        skip:0,
                        ticket_template_type:this.ticket_template_type || 'base'
                    }
                    let res = await this.getTemplateByDept(params)
                    // cons
                    this.ajaxCallinprogress = false
                    this.ticket_type_options = res.response.all_templates
                    if(res.response.all_templates.length > 1) {
                        this.check_ticket_template_type = 'Product' || 'Equipment';
                    }
                    else {
                        this.check_ticket_template_type = res.response.all_templates[0].name
                        this.behalf = 'myself'
                        this.behalfChange('myself');
                    }
                    if(this.ticket_type_options && this.ticket_type_options.length){
                        if(!this.is_parent_ticket){
                            if(this.nameOfTicket != ''){
                               this.ticket_type_options.forEach((el,index)=>{
                                   if(el.name == this.nameOfTicket){
                                      this.ticketType  = el
                                   }
                               })
                            }else{

                            }
                        }else{
                            this.ticketType = this.ticket_type_options[0]
                        }
                    }
                }
           } catch (reason) {

           }
        },
        async getParentTicketData() {
            let param = {
                ticket_id: this.$route.params.id,
            }
            let res = await this.getDueDate(param);
            if(this.$route.params.id) {
                this.is_service_ticket = true
                this.is_parent_ticket = false;
            }
            this.customer = {
                label: res.response.on_behalf_of.details.company_name.name
            }
            this.branch_name = {
                name: res.response.on_behalf_of.details.branch.name,
                _id: res.response.on_behalf_of.details.branch.id
            }
            this.authorized_person_name = res.response.on_behalf_of.details.company_name.name
            this.authorized_department = res.response.on_behalf_of.details.department[0]
            this.authorized_branch = res.response.on_behalf_of.details.branch.name
            this.authorized_email = res.response.on_behalf_of.details.email
            this.authorized_phone = res.response.on_behalf_of.details.phone_number
            this.authorized_person_id = res.response.on_behalf_of.details.company_name.id
            this.customer_address = res.response.customer_address
        },
        async getCameraSelection() {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoDevices = devices.filter(device => device.kind === 'videoinput');
            this.camera_selection = videoDevices;
            this.selected_camera_device = videoDevices[0].deviceId;
        },
        openCaptureImageMulti(field_index) {
            if(this.template_details[field_index].attach_files.length < 10){
                if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                    this.show_capture_image_multi = true;
                    setTimeout(() => {
                        this.$modal.show(`capture-image${field_index}`);
                        this.getCameraSelection()
                        this.toggleCameraMultiPart(field_index);
                    }, 500);
                }
                else {
                    this.warning_msg = "Camera capture device not found";
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        openCaptureImage() {
            if(this.attachments.length < 10){
                if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
                    this.show_capture_image = true;
                    setTimeout(() => {
                        this.$modal.show('capture-image');
                        this.getCameraSelection()
                        this.toggleCamera();
                    }, 500);
                }
                else {
                    this.warning_msg = "Camera capture device not found";
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        hideViewMultiPart(index){
            this.toggleCameraMultiPart(index)
        },
        hideView() {
            this.toggleCamera();
        },
        toggleCamera() {
            if(this.isCameraOpen) {
                this.stopCameraStream();
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
            } else {
                this.isCameraOpen = true;
                this.createCameraElement();
            }
        },
        toggleCameraMultiPart(field_index) {
            if(this.isCameraOpen) {
                this.stopCameraStreamMultiPart(field_index);
                this.isCameraOpen = false;
                this.isPhotoTaken = false;
                this.isShotPhoto = false;
            } else {
                this.isCameraOpen = true;
                this.createCameraElementMultiPart(field_index);
            }
        },
        createCameraElement() {
            this.isLoading = true;
            const constraints = (window.constraints = {
                audio: false,
                video: true
            });

            navigator.mediaDevices
                .getUserMedia(constraints)
                .then(stream => {
                this.isLoading = false;
                this.$refs.camera_capture.srcObject = stream;
            })
            .catch(error => {
                this.isLoading = false;
                this.show_capture_image = false;
                setTimeout(() => {
                    this.$modal.hide('capture-image');
                }, 500);
                alert("Please allow the camera access or your browser may not support it.");
            });
        },
        createCameraElementMultiPart(field_index) {
            this.isLoading = true;
            const constraints = (window.constraints = {
                audio: false,
                video: true
            });
            navigator.mediaDevices
                .getUserMedia(constraints)
                .then(stream => {
                this.isLoading = false;
                this.$refs.camera_capture[field_index].srcObject = stream;
            })
            .catch(error => {
                this.isLoading = false;
                this.show_capture_image_multi = false;
                setTimeout(() => {
                    this.$modal.hide(`capture-image${field_index}`);
                }, 500);
                alert("Please allow the camera access or your browser may not support it.");
            });
        },
        stopCameraStream() {
            let tracks = this.$refs.camera_capture.srcObject.getTracks();
            tracks.forEach(track => {
                track.stop();
            });
            this.show_capture_image = false;
            setTimeout(() => {
                this.$modal.hide('capture-image');
                this.stopCameraStream();
            }, 500);
        },
        stopCameraStreamMultiPart(field_index) {
            let tracks = this.$refs.camera_capture[field_index].srcObject.getTracks();
            tracks.forEach(track => {
                track.stop();
            });
            this.show_capture_image_multi = false;
            setTimeout(() => {
                this.$modal.hide(`capture-image${field_index}`);
                this.stopCameraStreamMultiPart(field_index);
            }, 500);
        },
        takePhoto() {
            if(!this.isPhotoTaken) {
                this.isShotPhoto = true;
                const FLASH_TIMEOUT = 50;
                setTimeout(() => {
                this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }
            this.isPhotoTaken = !this.isPhotoTaken;
            const context = this.$refs.canvas.getContext('2d');
            context.drawImage(this.$refs.camera_capture, 0, 0, 250, 250);
        },
        takePhotoMultiPart(field_index) {
            if(!this.isPhotoTaken) {
                this.isShotPhoto = true;
                const FLASH_TIMEOUT = 50;
                setTimeout(() => {
                this.isShotPhoto = false;
                }, FLASH_TIMEOUT);
            }
            this.isPhotoTaken = !this.isPhotoTaken;
            const context = this.$refs.canvas[field_index].getContext('2d');
            context.drawImage(this.$refs.camera_capture[field_index], 0, 0, 250, 250);
        },
        blobToFile(theBlob, fileName){
            //A Blob() is almost a File() - it's just missing the two properties below which we will add
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            const myFile = new File([theBlob], 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png', {
                type: theBlob.type,
            });
            return myFile;
        },
        uploadAttachmentFromCamera(file_data){
            let contains_duplicates = false
            this.attachments.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.attachments.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.attachments.push(attachment)
                    this.getResumableURL(file_data, this.attachments[this.attachments.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        uploadAttachmentFromCameraByPart(file_data, index){
            let contains_duplicates = false
            this.template_details[index].attach_files.forEach((e) => {
                if(e.name == file_data.name){
                    contains_duplicates = true
                }
            })
            if(this.template_details[index].attach_files.length < 10 && !contains_duplicates){
                if (file_data) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: file_data.name,
                        size: JSON.stringify(file_data.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[index].attach_files.push(attachment)
                    this.getResumableURLByPart(file_data, this.template_details[index].attach_files[this.template_details[index].attach_files.length - 1]);
                }
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }
        },
        getResumableURL(file, attachment) {
            this.isUploadingInProgress = true;
            attachment.uploading = true;
            let usage_type = {
                usage: "attachment"
            }
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                delete attachment['source'];
            })
            .catch(error => {
                console.log(error.data.reason)
            })
        },
        async downloadImageByPart(index){
            const canvas = document.getElementById('photoTaken').toDataURL("image/png")
            const base64 = await fetch(canvas);
            const blob = await base64.blob();
            let fill = this.blobToFile(blob, 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            this.uploadAttachmentFromCameraByPart(fill, index);
            this.show_capture_image_multi = false;
            this.$modal.hide(`capture-image${index}`);
            this.toggleCameraMultiPart(index)
            this.stopCameraStreamMultiPart(index);
        },
        async downloadImage() {
            const canvas = document.getElementById("photoTaken").toDataURL("image/png")
            const base64 = await fetch(canvas);
            const blob = await base64.blob();
            let fill = this.blobToFile(blob, 'captured_image' + (new Date().getHours()  + '' + new Date().getMinutes()  + '' + new Date().getSeconds()) +'.png');
            this.uploadAttachmentFromCamera(fill);
            this.show_capture_image = false;
            this.$modal.hide('capture-image');
            this.toggleCamera()
            this.stopCameraStream();
        },
        dropAttachmentDefaultFieldAttachment(evt, field_index) {
            evt.preventDefault();
            if(this.template_details[field_index].attachments.length + [...evt.dataTransfer.files].length <= 5){
                [...evt.dataTransfer.files].forEach((file, i) => {
                    this.uploadFromDropDefaultFieldAttachment(file, field_index)
                });
            } else {
                this.$toasted.global.error("Attachments limit should not exceed more than 5")
            }
        },
        dropAttachmentMPFieldAttachment(evt, part_index, field_index) {
            evt.preventDefault();
            if(this.template_details[part_index].parts_data[field_index].attachments.length + [...evt.dataTransfer.files].length <= 5){
                [...evt.dataTransfer.files].forEach((file, i) => {
                    this.uploadFromDropMPFieldAttachment(file, part_index, field_index)
                });
            } else {
                this.$toasted.global.error("Attachments limit should not exceed more than 5")
            }
        },
        uploadFromDropMPFieldAttachment(event, part_index, field_index) {
            let contains_duplicates = false
            this.template_details[part_index].parts_data[field_index].attachments.forEach((e) => {
                if(e.name == event.name){
                    contains_duplicates = true
                }
            })
            if(!contains_duplicates){
                if(event) {
                    var input = event;
                }
                if (input && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.name,
                        size: JSON.stringify(input.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[part_index].parts_data[field_index].attachments.push(attachment)
                    this.template_details[part_index].parts_data[field_index].attachment_error = false 
                    this.getResumableURLFieldAttachment(input, this.template_details[part_index].parts_data[field_index].attachments[this.template_details[part_index].parts_data[field_index].attachments.length - 1]);
                }
            } else {
                this.$toasted.global.error("This file is already uploaded")
            }
        },
        uploadFromDropDefaultFieldAttachment(event, field_index) {
            let contains_duplicates = false
            this.template_details[field_index].attachments.forEach((e) => {
                if(e.name == event.name){
                    contains_duplicates = true
                }
            })
            if(!contains_duplicates){
                if(event) {
                    var input = event;
                }
                if (input && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.name,
                        size: JSON.stringify(input.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[field_index].attachments.push(attachment) 
                    this.template_details[field_index].attachment_error = false 
                    this.getResumableURLFieldAttachment(input, this.template_details[field_index].attachments[this.template_details[field_index].attachments.length - 1]);
                }
            } else {
                this.$toasted.global.error("This file is already uploaded")
            }
        },
        uploadDefaultFieldAttachment(event, index){
            if(event) {
                var input = event.target;
            }
            let contains_duplicates = false
            this.template_details[index].attachments.forEach((e) => {
                if(e.name == input.files[0].name){
                    contains_duplicates = true
                }
            })
            if(!contains_duplicates){
                if (input.files && input.files[0] && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[index].attachments.push(attachment) 
                    this.template_details[index].attachment_error = false 
                    this.getResumableURLFieldAttachment(input.files[0], this.template_details[index].attachments[this.template_details[index].attachments.length - 1]);
                }
            } else {
                this.$toasted.global.error("This file is already uploaded")
            }
        },
        uploadMPFieldAttachment(event, part_index, field_index){
            if(event) {
                var input = event.target;
            }
            let contains_duplicates = false
            this.template_details[part_index].parts_data[field_index].attachments.forEach((e) => {
                if(e.name == input.files[0].name){
                    contains_duplicates = true
                }
            })
            if(!contains_duplicates){
                if (input.files && input.files[0] && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.template_details[part_index].parts_data[field_index].attachments.push(attachment) 
                    this.template_details[part_index].parts_data[field_index].attachment_error = false 
                    this.getResumableURLFieldAttachment(input.files[0], this.template_details[part_index].parts_data[field_index].attachments[this.template_details[part_index].parts_data[field_index].attachments.length - 1]);
                }
            } else {
                this.$toasted.global.error("This file is already uploaded")
            }
        },
        getResumableURLFieldAttachment(file, attachment) {
            this.isUploadingInProgress = true;
            attachment.uploading = true;
            let usage_type = {
                usage: "attachment"
            }
            let data = {
                file: attachment.name
            }
            data = new FormData()
            data.append('file',file)
            Object.keys(usage_type).map(e => {
                data.append(e, JSON.stringify(usage_type[e]))
            })
            this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data,{
                onUploadProgress: function (progressEvent) {
                    let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                    if (progress < 100) {
                        attachment.progress = progress;
                    }
                }.bind(this)
            })
            .then(response => {
                let resumable_url = response.data.url;
                attachment.url = resumable_url;
                attachment.progress = 100;
                attachment.uploading = false;
                this.isUploadingInProgress = false;
                delete attachment['source'];
                this.$forceUpdate()
            })
            .catch(error => {
                console.log(error.data.reason)
            })
        },
        dropDefaultAttachment(evt) {
            // Prevent default behavior (Prevent file from being opened)
            evt.preventDefault();
            // Use DataTransfer interface to access the file(s)
            [...evt.dataTransfer.files].forEach((file, i) => {
                    this.uploadDefaultFromDrop(file)
            });
        },
        uploadDefaultFromDrop(event){
            let contains_duplicates = false
            this.attachments.forEach((e) => {
                if(e.name == event.name){
                    contains_duplicates = true
                }
            })
            if(this.attachments.length < 10 && !contains_duplicates){
                if(event) {
                    var input = event;
                }
                if (input && event) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.name,
                        size: JSON.stringify(input.size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: ""
                    }
                    this.attachments.push(attachment);
                    this.getResumable(input, this.attachments[this.attachments.length - 1]);
                } 
            } else if(contains_duplicates){
                this.$toasted.global.error("This file is already uploaded")
            } else {
                this.$toasted.global.error("you're not allowed to upload more than 10 Attachments")
            }  
        },
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        getGeneralSettings(){
            return this.$store.state.store.getGeneralSettings
        },
        showDept(){
            return this.$store.state.store.showDepartment.display_department_section_in_base_template
        },
        onBehalf(){
            if(this.getGeneralSettings && this.getGeneralSettings.create_ticket_on_behalf_of){
                return this.getGeneralSettings.create_ticket_on_behalf_of.create_ticket_on_behalf_of
            }else{
                return ''
            }
        },
        showService(){
            return this.$store.state.store.showServiceTab.service_ticket_required
        },
        create_json(){
            return{
                assignment_details: {
                    id: this.assignedTo == 'unassigned' ? '' : this.assignedCustomer.id || '',
                    is_assigned: this.assignedTo == 'unassigned' ? false : true,
                    to: this.assignedTo
                },
                approvers_list: this.approvers_data.map(x => x.id),
                attach_files: this.attachments,
                description: this.description,
                subject: this.subject,
                template_data: this.template_details,
                ticket_template: this.ticketType._id
            }
        },
        create_multi_json(){
            let temp_template_details = []
            this.template_details.forEach((x, x_index) => {
                if(x_index == 0 || (!this.is_approvers_mandatory && x_index > 0)){
                    temp_template_details.push(x)
                }
            })
            return{
                assignment_details: {
                    id: this.assignedTo == 'unassigned' ? '' : this.assignedCustomer.id || '',
                    is_assigned: this.assignedTo == 'unassigned' ? false : true,
                    to: this.assignedTo
                },
                is_send_for_review: this.is_approvers_mandatory,
                approvers_list: this.approvers_data.map(x => x.id),
                attach_files: this.attachments,
                description: this.description,
                subject: this.subject,
                template_data: temp_template_details,
                ticket_template: this.ticketType._id
            }
        },
        save_as_draft(){
            return{
                assignment_details:{
                    id: this.assignedCustomer.id || '',
                    is_assigned:true,
                    to:this.assignedTo
                },
                creation_details:{
                    for:this.behalf,
                    id:this.authorized_person_id,
                    branch: {
                        name: this.branch_name.name,
                        id: this.branch_name._id
                    },
                },
                department:this.department._id || '',
                description:this.description,
                is_parent_ticket:this.is_parent_ticket,
                parent_ticket_id:this.$route.params.id ? this.$route.params.id : this.parent_ticket_id,
                subject:this.subject,
                is_validated:this.is_validated,
                customer_address:this.customer_address,
                job_type: this.job_type,
                ticket_template:this.ticketType._id || '',
            }
        },
        searchTemplate(){
            return debounce(this.searchTemplateDebouncer, 500)
        },
        searchTemplateApiDD(){
            return debounce(this.searchTemplateApiDDDebouncer, 500)
        },
        searchApiDD(){
            return debounce(this.searchApiDDDebouncer, 500)
        },
        getAllAssignTo(){
            return debounce(this.getAllAssignToDebouncer, 500)
        },
        watchApprovers(){
            let temp_approvers_options = this.approvers_options.map(x => x.id)
            let temp_approvers_data = this.approvers_data.map(x => x.id)
            return temp_approvers_options.length == temp_approvers_data.length
        }
    },
    mounted(){
        if(this.$route.params.id) {
            this.ticket_template_type = "service";
            this.getParentTicketData();
        }
    },
    created(){
        // this.searchTemplate = debounce(this.searchTemplateDebouncer, 500)
        // this.searchTemplateApiDD = debounce(this.searchTemplateApiDDDebouncer, 500)
        // this.searchApiDD = debounce(this.searchApiDDDebouncer, 500)
        // this.getAllAssignTo = debounce(this.getAllAssignToDebouncer, 500)
        const dict = {
            custom: {
                customer:{
                    required:() => "Customer is Required",
                },
                vendor:{
                    required:() => "Vendor is Required",
                },
                subject:{
                    required:() => "Ticket Subject is Required",
                },
                department:{
                    required:() => "Department is Required",
                },
                assigned:{
                    required:() => "Assigned to is Required",
                },
                ticketType:{
                    required:() => "Ticket Template is Required"
                },
                branch_name:{
                    required:() => "Branch Name is Required"
                },
            }
        }
        this.$validator.localize("en", dict);
    }
}
</script>
<style scoped>
.activeDetails{
    background-color: #00448f !important;
    color: #fff !important;
    width: 200px !important;
    border-radius: 14px !important;
    height: 40px !important;
    font-weight: 500 !important;
    text-transform: none;
    font-size: 16px !important;
}
.boxHeader{
    background: #005dae;
    color: #fff;
    padding: 5px 25px;
    font-weight: 500;
    font-size: 14px;
}
.boxShadow{
    box-shadow: 0px 0.5px 7px 2px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    border-radius: 8px;
}
.vendor_type span{
    margin-left: 10px;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #000000;
}
.btn-blue{
    background: #005dae;
    color: #fff;
}
.ticket_decription{
    border: 1px solid #707070;
    border-radius: 10px;
    margin-left: 10px;
}
.ticket_decription .quillWrapper .ql-toolbar.ql-snow .ql-formats:nth-child(8){
    display: none !important;
}
.decription{
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 8px 25px;
    font-size: 14px;
    font-weight: 600;
    border-bottom: 1px solid #303031;
}
.dlt_descs{
    float: right;
    position: relative;
    bottom: 30px;
    right: 10px;
}
.btn-upload {
    background: #00448b;
    border-radius: 15px !important;
    text-transform: none !important;
    padding: 6px 18px !important;
    font-weight:500 !important;
}
.btn-upload-disabled{
    background: #e8e8e8 !important;
    border-radius: 15px !important;
    text-transform: none !important;
    padding: 6px 18px !important;
    font-weight:500 !important;
}
.attachment-bg-new{
    border: 1px solid #005dae !important;
    background: transparent !important;
    width: 100%;
}
.file-bg{
    background-color: #bbd9fd;
    padding: 10px;
    border-radius: 2px;
}
._wizardBox{
    background-color: #f4f9ff;
    border: #005dae;
    width: 50%;
    height: 100px;
    padding: 10px;
    position: relative;
    left: 25%;
}
#progressbar {
    margin-bottom: 10px;
    overflow: hidden;
    color: #303031;
    width: 100%;
    display: flex;
    margin: 0;
    padding: 0;
    align-items: center;
    justify-content: center;
}

#progressbar .active {
    color: #303031
}

#progressbar li {
    list-style-type: none;
    font-size: 12px;
    width: 33%;
    position: relative;
    text-align: center;
}
#progressbar li strong {
    display: block;
    opacity: 0.5;
}

#progressbar li strong.active {
    opacity: 1;
}

#progressbar li img {
    position: relative;
    z-index: 2;
}
#progressbar li:before {
    content: '';
    width: 100%;
    border-top: dashed 2px #cdcdcd;
    position: absolute;
    left: -50%;
    top: 27px;
    z-index: 1
}
#progressbar li:first-child::before{
    width: 0% !important;
}
#progressbar li.active:before {
    border-top: solid 2px #005dae;
}
.inputLabel {
    margin-left: 6px;
}
.jobHide{
    margin-top: 14px !important;
}
.page-layout.blank {
    overflow: inherit;
}
.desc-textarea {
    padding-top: 6px!important;
    width: 100%;
    background: transparent;
    color: #303031;
    /* border-radius: 5px; */
    border: none !important;
    border-bottom: 2px solid #0d84f2 !important;
    resize: none;
    padding: 10px;
    overflow-y: auto;
    padding-right: 75px!important;
    min-height: 140px;
}
.desc-editor{
    background: transparent;
    color: #303031;
    font-size: 14px !important;
    display: block;
    width: 100%;
    border-radius: 5px;
    border: solid 1px #3f3f3f!important;
    background: transparent !important;
    font-weight: 500;
    border-radius: 5px !important;
}
.bord-left .mx-input{
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
}
.diginewhelp-multiselect {
    font-weight: 600;
    color: #7B7F83 !important;
}
.gps-logo{
    border-radius: 5px;
    padding: 5px;
    border: 1px solid rgb(0, 0, 0);
    position: relative;
    top: 5px;
    margin-left: 5px;
}
.color-blue{
    color: #005dae;
}
.text-grey{
    color: #656565;
}
.filterSelectedName{
    position: relative;
    top:3px;
}
.filterSelectedName1{
    position: relative;
    top:0px;
}
.w-150{
    width: 150px !important;
}
.word-wrap{
    word-break: break-all !important;
    white-space: pre-wrap;
}
.h-100{
    height: 100% !important;
}
.dynamic-section{
    /* background-color: rgba(0, 0, 0, 0.05) !important; */
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
    border-radius: 6px !important;
}
.dynamic-section .table-content .table-content-data thead tr th{
    background-color: #0d84f2;
}
.dynamic-section .table-content .table-content-data tbody tr td{
    background-color: #cce3fc;
}
.infoHeader>.descriptionheader .description-text-header-right img{
    width: 23px !important;
}
.approved-btn{
    background-color: #40ad5c;
}
.rejected-btn{
    background-color: #F44336 !important;
}
.approved-btn, .rejected-btn{
    width:92px !important;
    padding: 5px 10px;
    border-radius: 5px !important;
    color: #fff;
    text-align: center;
}
.filter-multiple .custom__tag {
    background: #81aee6;
    color: #fff;
    padding: 2px 8px !important;
    border-radius: 20px;
    margin-right: 5px !important;
    display: inline-block;
    margin-bottom: 5px !important;
}

.filter-multiple .custom__tag1 {
    background: #81aee6;
    color: #fff;
    padding: 4px 8px !important;
    border-radius: 20px;
    margin-right: 5px !important;
    display: inline-block;
    margin-bottom: 5px !important;
}

.filter-multiple .custom__tag .custom__remove i {
    position: relative;
    top: -3px;
    right: -3px;
}
.filter-multiple .custom__tag1 .custom__remove i {
    position: relative;
    top: 0px;
    right: -3px;
}
.bg-grey{
    background-color: rgba(0,0,0,0.06) !important;
}
.text-reason{
    font-size: 14px !important;
    padding: 5px 5px 40px 10px !important;
    display: block;
    width: 100%;
    border-radius: 5px;
    border: solid 1px #3f3f3f!important;
    background: transparent !important;
    color: #000;
    font-weight: 500;
    border-radius: 5px !important;
    margin-top: 20px;
    /* margin-left:20px; */
}
.inverse div{
     position: absolute;
     top: 27px;
     width: 11px;
     height: 11px;
     border-radius: 50%;
     background: #fff;
     animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.h-100{
    height: 100% !important;
}
.position-absolute{
     position: absolute !important;
}
.cursor-notallowed{
    cursor: not-allowed !important
}
.text-align-left{
    text-align: left;
}
.w-90{
    width: 90px !important;
}
.w-130{
    width: 130px !important
}
.w-140{
    width: 140px !important;
}
.text-grey{
    color: #abaaac;
}
.bg-grey-box{
    background: #f1f3f4
}
.dotted-grey{
    border: dotted 2px #89898d;
}
.no-att-msg{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: rgba(59, 77, 92, 0.16);
}
.browse-box{
    height: 200px;
}
.choose-file{
    border-radius: 5px !important;
}
.fs-15px{
    font-size: 15px !important
}
.mx-width-220{
    max-width: 285px !important;
}
@media screen and (max-width: 768px) {
    .p-med-12{
        padding-left: 12px !important;
        padding-right: 12px !important;
        padding-top: 12px;
    }
    .pl-med-12{
        padding-left: 12px !important;
    }
    .justify-center-frsm{
        justify-content: center;
    }
}
.paste-input::placeholder{
    font-weight: 400 !important;
} 
</style>